import React, { useEffect, useRef } from "react";
import "../../../../css/Sales/Billingnew.css";
import { useState } from "react";
import {
  Autocomplete,
  Backdrop,
  Dialog,
  IconButton,
  Skeleton,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { categoryListAPICall } from "../../Inventory/Configuration/Category/CategoryAPI";
import KeyboardIcon from '@mui/icons-material/Keyboard';
import {
  comboOffersProductsListForBilling,
  getAllSubCatForBilling,
  getBranchConfiguration,
  getCheckInDetail,
  getVerifypassword,
  paymentTypesForBilling,
  specialOfferProductsListForBilling,
} from "./newBillingAPI";
import { branchSettingsSingleView } from "../../PointOfSale/Configuration/BranchSettings/BranchSettingsAPI";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import photo from "../../../../Assets/Images/b1fac8457e015cf2d2dcf2fbebe8c9f2.jpg"
import logo from "../../../../Assets/Images/Thali-Pe-updated-Png-123.png"
import {
  areArraysEqual,
  getTodaysLowerCaseDay,
  numToWords,
  roundNumericFields,
  urlToBlob,
} from "../../../../Js/generalFunctions";
import { PrintOutlined } from "@mui/icons-material";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { getCurrentTime, today } from "../../../../Js/Date";
import { useReactToPrint } from "../../../Shared/print/useHtml2PdfPrint";
import html2pdf from "html2pdf.js";
import { getPPI } from "../../../Shared/print/printUtils";
import dummyProductItemImg from "../../../../Assets/BillingImages/emptyFoodImg.svg";
import emptyCartItemImg from "../../../../Assets/BillingImages/emptyCart.svg";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import "../../../../css/Orders/viewOrder.css";
import "../../../../css/Purchase Manager/purchaseOrder.css";
import { setCartProductType, switch_to_billing_screen } from "./newBillingSlice";
import TopBar from "./Components/TopBar";
import {
  setBtnSelected,
  setCustomer,
  setOrderWaiter,
  setSearchBarInput,
  setSelfDeliveryKm,
  setSelfDeliveryCharge,
} from "./Components/topBarSliceBilling";
import BillingPayment from "./Components/BillingPayment";
import ViewOrders from "./Components/ViewOrders";
import BillingFloorPlan from "./Components/BillingFloorPlan";
import { listAllFloorAPI } from "../../FloorManagement/addSeat/floorManagementApi";
import {
  setBillLoading,
  setCartTOBackend,
  setDialogBox,
  setKOTManualDialog,
  setKOTSingleInfo,
  setOrderIdInPOS,
  setPOSBranchId,
  setPageIndex,
  setPagination,
  setSelectedPosCat,
  setSingleOrderInfo,
} from "./Slice/billingScreenSlice";
import {
  addPOSOrderWoFloorSelectionAPI,
  addPOSOrdertoKOT,
  holdPOSOrderAPI,
  quickBillOrderAPI,
  singlePOSOrderInfoAPICall,
  updatePosOrderAPICall,
} from "./API/billingScreenSection";
import { viewCardManualAPICall } from "../../../../API/Settings/CardAndUpiType/cardManualAPI";
import {
  listHeldOrders,
  createPosNoteApiCall,
  listPosNotesApiCall
} from "./API/viewOrderSection";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CategoryEmptyAnimation from "./Gif/CategoryEmptyAnimation";
import brokenImg from "./image/picture.png";
import ArrowPath from "./Utilities/ArrowPath";
import { clearPathData, setArrowPathData } from "./Utilities/ArrowPathSlice";
import { listSpecialItemsForBilling } from "../SpecialItems/specialItemsApi";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import TableRestaurantTwoToneIcon from "@mui/icons-material/TableRestaurantTwoTone";
import PosReceiptTemplate from "../../components/template/posReceipt/PosReceiptTemplate";
import { getTemplateInfoAPI } from "../../Settings/posReceipt/posReceiptApi";
import { setPosReceiptSlice } from "../../Settings/posReceipt/posReceiptSlice";
import { listAggregatorsAPI } from "../../PointOfSale/Configuration/Aggregator/aggregatorAPI";
import ReservationBilling from "./Components/ReservationBilling";
import { listReservationList } from "./API/billingReservation";
import io from "socket.io-client";
import axios from "axios";
// AI Components for Smart Recommendations, Voice Ordering, and Customer Intelligence
import { SmartRecommendations, VoiceOrdering, CustomerIntelligence } from "./Components/AI";
// AI Feature Permissions
import { hasPermission, checkAiFeatureDisabled } from "../../../../utils/permissions";
import hybridSocket from "../../../../offline/hybridSocket";
import CustomeKeyBoard from "../../../Single Components/CustomeKeyBoard";
import ButtonWithIcon from "../../../Single Components/Buttons/ButtonWithIcon";
import KotPrint from "../../kitchenOrderTicket/components/print/KotPrint";
import { Loader } from "../../../Single Components/Loader";
import { kotPrintRequestAPICall, printRequestAPICall, qzTrayPdfPrintAPICall, qzTrayKotPrintAPICall } from "../../Settings/Device Settings/deviceSettingsAPI";
import { isQzTrayAvailable } from "../../Settings/Device Settings/qzTrayService";
import { setPosPrinterDevice, setPrinterList } from "../../Settings/Device Settings/deviceSettingsSlice";
import { setPosDevice } from "./Slice/posDeviceSlice";
import ProductCreatePopup from "../../Inventory/Products/ProductCreatePopup";
import UpdateOrderAuth from "./Components/UpdateOrderAuth";
import ListNotes from "./Components/ListNotes";
import PremiumBillingTheme from "./Themes/PremiumBillingTheme";
import ProductsList from "./Components/ProductsList";
import useProducts from "./Utilities/useProducts";
import { defaultCustomerForPOSAPI } from "./API/billingFloorSection";
import { completedSelfOrderLists } from "../../../../SelfOrderComponents/Components/Order/selfOrderListingAPI";
import { errorSnackMsg, successSnackMsg } from "../../../Custom Hooks/SnackkBarUtilities";
import { viewPosSettingsAPICall } from "../../PointOfSale/Configuration/Settings/posSettingsAPI";
import Decimal from "decimal.js";
import SuccessSnackbar from "../../../Single Components/SnackBars/SuccessSnackbar";
import ErrorSnackbar from "../../../Single Components/SnackBars/ErrorSnackbar";
import { useNavigate, useLocation } from "react-router-dom";
import { sendWhatsAppMessageAPI } from "../../PointOfSale/Configuration/BranchSettings/BranchSettingsAPI";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import CachedImage from "../../../../offline/components/CachedImage";
import db from "../../../../offline/db";
import useRefreshPrevention from "../../../../offline/useRefreshPrevention";
export const BillingNew = () => {
  const dispatch = useDispatch();
  let navigateTo = useNavigate();
  const location = useLocation();
  
  // Prevent page refresh when offline with pending transactions
  const { isBlocking, pendingCount, offlineOrdersCount } = useRefreshPrevention({ 
    enabled: true, 
    showWarning: true 
  });
  
  // Hide the sidemenu on mount & measure AppBar height dynamically
  useEffect(() => {
    dispatch(switch_to_billing_screen({ billingBoolean: true }));
    document.body.style.overflow = 'hidden';
    const setAppBarHeight = () => {
      const appBar = document.querySelector('.MuiAppBar-root');
      if (appBar) {
        const h = appBar.offsetHeight;
        document.documentElement.style.setProperty('--appbar-height', h + 'px');
      }
    };
    setAppBarHeight();
    setTimeout(setAppBarHeight, 300);
    const observer = new MutationObserver(() => {
      requestAnimationFrame(setAppBarHeight);
    });
    const appBar = document.querySelector('.MuiAppBar-root');
    if (appBar) {
      observer.observe(appBar, { attributes: true, childList: true, subtree: true });
    }
    return () => {
      observer.disconnect();
      document.body.style.overflow = '';
    };
  }, [dispatch]);

  // If navigated from NotificationCenter with a specific tab (e.g., heldOrder for ongoing orders),
  // switch the Billing screen to that tab instead of whatever was previously selected.
  useEffect(() => {
    const targetTab = location?.state?.tab;
    if (targetTab === 'heldOrder') {
      dispatch(setBtnSelected('heldOrder'));
    }
  }, [location?.state, dispatch]);

  // Load order from React Router state (for ecommerce "Confirm & Pay" flow)
  useEffect(() => {
    console.log('📦 [BILLING] Component mounted/updated');
    console.log('📦 [BILLING] location:', location);
    
    // Check for orderId in location state (from ecommerce navigation)
    const stateOrderId = location.state?.orderId;
    const fromEcommerce = location.state?.fromEcommerce;
    
    console.log('📦 [BILLING] stateOrderId:', stateOrderId);
    console.log('📦 [BILLING] fromEcommerce:', fromEcommerce);
    
    if (stateOrderId && fromEcommerce) {
      console.log('📦 [BILLING] Loading ecommerce order from state:', stateOrderId);
      console.log('📦 [BILLING] Switching to payment tab');
      
      // Clear any existing order first
      dispatch(setSingleOrderInfo(null));
      
      // Set the order ID and switch to payment tab
      dispatch(setOrderIdInPOS(stateOrderId));
      dispatch(setBtnSelected('payment'));
      
      // Clear the state to prevent re-triggering on back navigation
      window.history.replaceState({}, '', '/userdashboard/billing');
      return;
    }
    
    // Also check URL parameter for backward compatibility
    const searchParams = new URLSearchParams(location.search);
    const orderIdFromUrl = searchParams.get('orderId');
    
    console.log('📦 [BILLING] orderIdFromUrl:', orderIdFromUrl);
    
    if (orderIdFromUrl) {
      console.log('📦 [BILLING] Loading order from URL:', orderIdFromUrl);
      console.log('📦 [BILLING] Switching to payment tab');
      
      // Clear any existing order first
      dispatch(setSingleOrderInfo(null));
      
      // Set the order ID and switch to payment tab
      dispatch(setOrderIdInPOS(orderIdFromUrl));
      dispatch(setBtnSelected('payment'));
      
      // Clear the URL parameter after loading to prevent re-triggering
      window.history.replaceState({}, '', '/userdashboard/billing');
    } else {
      console.log('📦 [BILLING] No orderId found in state or URL');
    }
  }, [location, dispatch]);

  // Load POS Settings (includes billing UI configuration like card view/size)
  useEffect(() => {
    viewPosSettingsAPICall();
  }, []);
  // useref
  let invoicePrint = useRef();
  const categoryArrayRef = useRef(null);
  const kotPrintRef = useRef(null);
  // Recipe components map for KOT raw material filter (productId → components[])
  const recipeMapRef = useRef(null);
  useEffect(() => {
    axios.get("foodManagement/getRecipeComponentsMap")
      .then(res => {
        if (res.status === 200 && res.data) {
          recipeMapRef.current = res.data;
          console.log('✅ Recipe components map loaded:', Object.keys(res.data).length, 'products have recipes');
        }
      })
      .catch((err) => console.error('❌ Failed to load recipe map:', err?.response?.status || err?.message));
  }, []);
  // locallyStored items
  const decimalPosition = Number(localStorage.getItem("decimalPosition"));
  const shiftStatus = useSelector((state) => state.shiftStatusSlice.value);


  // global states
  const { keyBoardVisible } = useSelector((state) => state.customKeyBoardSlice);
  const { currencyDetails, tableLoading } = useSelector((state) => state.mainDashBoardSlice)
  const { posTemplateSelected } = useSelector((state) => state.posReceiptSlice);
  const posSettingsList = useSelector((state) => state.posSettingSlice.apiResList);
  const roundOff = posSettingsList?.enableRoundOff || false;

  // Cache UI settings in localStorage as fallback
  useEffect(() => {
    if (!posSettingsList) return;

    if (posSettingsList?.billingTheme) {
      localStorage.setItem('billingTheme', posSettingsList?.billingTheme);
    }
    if (posSettingsList?.billingPaymentTypeView) {
      localStorage.setItem('billingPaymentTypeView', posSettingsList?.billingPaymentTypeView);
    }
    if (posSettingsList?.billingItemCardView) {
      localStorage.setItem('billingItemCardView', posSettingsList?.billingItemCardView);
    }
    if (posSettingsList?.billingItemCardSize) {
      localStorage.setItem('billingItemCardSize', posSettingsList?.billingItemCardSize);
    }
  }, [posSettingsList]);
  const branchSettingsView = useSelector(
    (state) => state.branchSettingsSliceNew.rowData
  );
  const posDeviceState = useSelector((state) => state.posDeviceSlice);
  // console.log(branchSettingsView, 'branchSettingsView')
  // const roundOff = useSelector((state) => state.posSettingsList.enableRoundOff);
  // store states from topbar
  const {
    btnClicked,
    billType,
    customer,
    defaultCustomer,
    aggregator,
    searchBarInput,
    waiter,
    aggregatorRef,
    selfDeliveryCharge,
    selfDeliveryKm,
    deliveryBoy
  } = useSelector((state) => state.topBarSliceBilling);

  // floorManagment states
  const { floors } = useSelector((state) => state.addSeatSlice);
  // billingSlice states
  const {
    orderIdForPos,
    dialogOpen,
    billLoading,
    singleOrderInfo,
    categoryLoading,
    posCategoryLoading,
    selectedPOSCategory,
    kotSingleData,
    kotManualDialog
  } = useSelector((state) => state.billingScreenSlice);
  const { specialItemsListForBilling } = useSelector((state) => state.specialItemsSlice);
  const { productType, authPassWord, branchConfigurationList, checkInDetail, checkInPass, productsList } = useSelector((state) => state.newBillingSlice);
  const { receiptData } = useSelector((state) => state.viewOrdersBillingSlice);
  const [isTotalExpanded, setIsTotalExpanded] = useState(false);
  const [billingTheme, setBillingTheme] = useState('classic');
  // Ensure branch is available before effects/functions use it
  const userInfo = useSelector((state) => state.loginResponseSlice.value);
  // Try branchPk from Redux, fallback to localStorage
  const storedBranchId = localStorage.getItem("branchId");
  const userBranchId = (userInfo?.branchPk && userInfo?.branchPk !== "noBranch") 
    ? userInfo?.branchPk 
    : storedBranchId;
  
  // AI Feature Permissions - check from roles/permissions
  // Default to TRUE (enabled) if permission not explicitly set - AI features are opt-out, not opt-in
  const canUseVoiceOrdering = React.useMemo(() => {
    const hasExplicitPermission = hasPermission('POS.AI.VOICE_ORDERING');
    const isExplicitlyDisabled = checkAiFeatureDisabled('voiceOrdering');
    const result = hasExplicitPermission || !isExplicitlyDisabled;
    console.log('🎤 Voice Ordering Permission:', { hasExplicitPermission, isExplicitlyDisabled, result });
    return result;
  }, []);
  const canUseSmartSuggestions = React.useMemo(() => {
    const hasExplicitPermission = hasPermission('POS.AI.SMART_SUGGESTIONS');
    const isExplicitlyDisabled = checkAiFeatureDisabled('smartSuggestions');
    const result = hasExplicitPermission || !isExplicitlyDisabled;
    console.log('💡 Smart Suggestions Permission:', { hasExplicitPermission, isExplicitlyDisabled, result });
    return result;
  }, []);
  const canUseCustomerIntelligence = React.useMemo(() => {
    const hasExplicitPermission = hasPermission('POS.AI.CUSTOMER_INTELLIGENCE');
    const isExplicitlyDisabled = checkAiFeatureDisabled('customerIntelligence');
    const result = hasExplicitPermission || !isExplicitlyDisabled;
    console.log('🧠 Customer Intelligence Permission:', { hasExplicitPermission, isExplicitlyDisabled, result });
    return result;
  }, []);

  // Ensure templates are loaded when Add Note dialog opens
  useEffect(() => {
    if (dialogOpen === "addNote" && userBranchId) {
      listPosNotesApiCall({ branchId: userBranchId });
    }
  }, [dialogOpen, userBranchId]);

  // Helper functions for premium theme
  const handleIncrement = (index) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].quantity = Number(updatedCartItems[index].quantity) + 1;
    setCartItems(updatedCartItems);
    setIsCartModified(!isCartModified);
  };

  // Save current input as a reusable note template
  const saveNoteTemplate = async () => {
    const newText = (input || "").toString().replace(/\r\n/g, "\n").trim();
    if (!newText) return;
    await createPosNoteApiCall({ branchId: userBranchId, notes: newText }, () => {
      listPosNotesApiCall({ branchId: userBranchId });
    });
  };

  const handleDecrement = (index) => {
    const updatedCartItems = [...cartItems];
    const newQty = Number(updatedCartItems[index].quantity) - 1;
    if (newQty > 0) {
      updatedCartItems[index].quantity = newQty;
      setCartItems(updatedCartItems);
      setIsCartModified(!isCartModified);
    }
  };

  const handleDeleteCartItem = (index) => {
    handleDelete(index);
  };

// console.log(singleOrderInfo);

  // Debug kotSingleData
  useEffect(() => {
    if (kotSingleData) {
      console.log('kotSingleData updated:', kotSingleData);
      console.log('kotSingleData.orderInfo:', kotSingleData.orderInfo);
    }
  }, [kotSingleData]);

  //initial API Responses
  // userInfo is declared earlier (near top) to be available for effects; avoid redeclaration here
  // console.log(userInfo);

  const CategoryList = useSelector((state) => state.categorySlice.value);
  // console.log(CategoryList,"CategoryList")
  // const {aggregatorList}=useSelector((state)=>state.aggregatorSlice)
  // console.log(aggregatorList?.aggregatorCategoryId,"aggregatorList")
  const posCategoryList = useSelector((state) => state.newBillingSlice.subCategoryList);
  const allActiveEmpList = useSelector((state) => state.allActiveEmployeeSlice.value);
  const companyProfileData = useSelector((state) => state?.companyProfileSlice?.userValue)
  const userRole = useSelector((state) => state.userRoleSlice.value);
  const posSettings = useSelector((state) => state.posSettingSlice.apiResList);
  const customerPaymentStatus = posSettings?.customerStatus;
  const employeeId = userInfo?.data?._id;
  // Resolve assigned POS device for current employee from branch settings
  const assignedDevice = React.useMemo(() => {
    if (posDeviceState?.deviceId && posDeviceState?.deviceName) {
      return {
        _id: posDeviceState.deviceId,
        deviceName: posDeviceState.deviceName,
        assignedEmployees: posDeviceState.assignedEmployees || [],
        assignedCategories: posDeviceState.assignedCategories || [],
        allowSpecialItems: Boolean(posDeviceState.allowSpecialItems),
      };
    }
    const devices = branchSettingsView?.posDevices || [];
    if (!Array.isArray(devices) || !employeeId) return null;
    const fallback =
      devices.find((d) =>
        Array.isArray(d?.employees) &&
        d.employees.some((e) => {
          const empId = e?.employeeId || e?.empId || e?._id;
          return empId && empId.toString() === employeeId?.toString();
        })
      ) || null;
    if (!fallback) return null;
    return {
      _id: fallback?._id?.toString() || fallback?.deviceId,
      deviceName: fallback?.deviceName || fallback?.name,
      assignedEmployees: Array.isArray(fallback?.employees)
        ? fallback.employees
            .map((emp) => {
              const empId = emp?.employeeId || emp?.empId || emp?._id;
              if (!empId) return null;
              return {
                employeeId: empId.toString(),
                employeeName: emp?.employeeName || emp?.name || emp?.staff_name || "",
              };
            })
            .filter(Boolean)
        : [],
      assignedCategories: Array.isArray(fallback?.categories)
        ? fallback.categories.map((cat) => ({
            categoryId: (cat?.categoryId || cat?._id)?.toString?.() || null,
            categoryName: cat?.categoryName || cat?.name || "",
          })).filter((cat) => cat.categoryId || cat.categoryName)
        : [],
      allowSpecialItems: Boolean(
        fallback?.allowSpecialItems ?? fallback?.specialPosCategory
      ),
    };
  }, [branchSettingsView?.posDevices, employeeId, posDeviceState?.assignedCategories, posDeviceState?.assignedEmployees, posDeviceState?.deviceId, posDeviceState?.deviceName]);

  const assignedCategoryIds = React.useMemo(() => {
    if (!assignedDevice) return null;
    const ids = (assignedDevice.assignedCategories || [])
      .map((cat) => cat?.categoryId)
      .filter(Boolean);
    return ids.length > 0 ? ids : null;
  }, [assignedDevice]);

  // Filter subcategories based on assigned categories
  const filteredPosCategoryList = React.useMemo(() => {
    if (!assignedCategoryIds || !posCategoryList) return posCategoryList;
    
    const filtered = posCategoryList.filter((subCat) => {
      // Subcategories use 'catId' field to reference parent category
      const parentCategoryId = subCat?.catId?.toString();
      if (!parentCategoryId) return false;
      
      return assignedCategoryIds.includes(parentCategoryId);
    });
    
    return filtered;
  }, [posCategoryList, assignedCategoryIds]);

  const canUseSpecialItems = React.useMemo(() => {
    // If device assigned, check device-specific setting
    if (assignedDevice) {
      return Boolean(assignedDevice?.allowSpecialItems);
    }
    
    // If no device assigned to this employee, they can see everything including special items
    // This is the default behavior - only device-assigned employees have restrictions
    return true;
  }, [assignedDevice]);

  const assignedEmployeeSnapshot = React.useMemo(() => {
    if (!assignedDevice) return { assignedEmployeeId: null, assignedEmployeeName: null };
    const firstEmp = (assignedDevice.assignedEmployees || [])[0];
    return {
      assignedEmployeeId: firstEmp?.employeeId || null,
      assignedEmployeeName: firstEmp?.employeeName || null,
    };
  }, [assignedDevice]);

  const isCategoryAllowedForDevice = React.useCallback(
    (categoryId) => {
      if (!assignedCategoryIds) return true;
      if (!categoryId) return false;
      return assignedCategoryIds.includes(categoryId.toString());
    },
    [assignedCategoryIds]
  );

  const isProductAllowedForDevice = React.useCallback(
    (product) => {
      if (!assignedCategoryIds) return true;
      const productCategories = [
        product?.mainCatgeoryId,
        product?.categoryId,
        ...(Array.isArray(product?.categoryIds) ? product.categoryIds : []),
      ]
        .filter(Boolean)
        .map((id) => id.toString());
      return productCategories.some((id) => assignedCategoryIds.includes(id));
    },
    [assignedCategoryIds]
  );
  
  // Build products API payload - include categoryIds if device has restrictions
  const productsPayload = React.useMemo(() => {
    const payload = { branchId: userBranchId, isPos: true };
    if (assignedCategoryIds && assignedCategoryIds.length > 0) {
      payload.categoryIds = assignedCategoryIds;
    }
    return payload;
  }, [userBranchId, assignedCategoryIds]);

  const { data: productsData } = useProducts(productsPayload);

  // Force reload products when assigned categories change
  React.useEffect(() => {
    if (assignedCategoryIds && assignedCategoryIds.length > 0) {
      sessionStorage.removeItem('productsData');
    }
  }, [assignedCategoryIds?.length]);

  // console.log('Current aggregator:', aggregator);
  // console.log('CategoryList:', CategoryList);
  // Filter categories based on aggregator selection

  const getFilteredCategories = () => {
    // Always show all categories if:
    // - Not in Delivery mode OR
    // - No aggregator selected OR 
    // - Aggregator has empty category array
    
    // Ensure CategoryList is an array
    if (!Array.isArray(CategoryList)) {
      return [];
    }
    
    let availableCategories = CategoryList;
    if (assignedCategoryIds) {
      availableCategories = CategoryList.filter((category) =>
        assignedCategoryIds.includes(category?._id?.toString?.())
      );
    }
    if (billType !== "DELIVERY" || !aggregator || aggregator.aggregatorCategoryId?.length === 0) {
      return availableCategories || [];
    }

    // Only filter if:
    // - In Delivery mode AND
    // - Aggregator selected AND
    // - Aggregator has specific category restrictions
    return availableCategories.filter((category) =>
      aggregator.aggregatorCategoryId.includes(category._id)
    ) || [];
  };
  //   const getFilteredCategories = () => {
  //     // Always return all categories if not Delivery
  //     if (billType !== "DELIVERY") {
  //         return CategoryList;
  //     }

  //     // Only filter if Delivery and aggregator with categories is selected
  //     if (aggregator && aggregator.aggregatorCategoryId && aggregator.aggregatorCategoryId.length > 0) {
  //         return CategoryList.filter(category => 
  //             aggregator.aggregatorCategoryId.includes(category._id)
  //         );
  //     }

  //     return CategoryList;
  // };
  // const getFilteredCategories = () => {
  //   if (!aggregator) return CategoryList;

  //   // Check both possible field names for categories
  //   const categoryIds = aggregator.aggregatorCategoryId || aggregator.categoriesId || [];

  //   if (categoryIds?.length > 0) {
  //     return CategoryList?.filter(category => 
  //       categoryIds?.includes(category._id)
  //     );
  //   }

  //   return CategoryList;
  // };
  // useStates

  const [input, setInput] = useState(""); //keypad button value
  const [inputSelection, setInputSelection] = useState(null); //keypad action selection

  const [isLoading, setIsLoading] = useState(false);
  const [selectedCartRow, setSelectedCartRow] = useState(null);

  const [isCartModified, setIsCartModified] = useState(false);
  const [duplicateCartArray, setDuplicateCartArray] = useState([]);

  const [cartItems, setCartItems] = useState([]);

  // console.log(cartItems, "cartItems in billing new")

  const qtyInputRefs = useRef(cartItems?.map(() => React.createRef()));
  const salesPriceRefs = useRef(cartItems?.map(() => React.createRef()));

  const [selectedPIndex, setSelectedPIndex] = useState("non-veg");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [specialItemCat, setSpecialItemCat] = useState(null);
  const [specialItemsOpen, setSpecialItemsOpen] = useState(false);
  const [showCheckinPopup, setShowCheckinPopup] = useState(false);
  const [showSecondCheckInPopup, setShowSecondCheckInPopup] = useState(false);
  const [enableKeybooard, setEnableKeybooard] = useState(false);
  const [password, setPassword] = useState(false);
  const [customerDisplayQRInfo, setCustomerDisplayQRInfo] = useState({ 
    open: false, 
    label: "", 
    bankAccount: "", 
    payeeName: "", 
    amount: "",
    currency: "AED",
    status: "pending" // pending, success, declined
  })
  // UPI payment webhook data (received via socket from backend)
  const [upiPaymentSuccessData, setUpiPaymentSuccessData] = useState(null)
  const [upiPaymentFailedData, setUpiPaymentFailedData] = useState(null)
  const [successSnackbar, setSuccessSnackbar] = useState(false)
  const [errorSnackbar, setErrorSnackbar] = useState(false)
  const [snackMsg, setSnackMsg] = useState('Error!!')

  const filteredCategories = getFilteredCategories();
  useEffect(() => {
    if (selectedCategory && !isCategoryAllowedForDevice(selectedCategory)) {
      setSelectedCategory(null);
    }
    if (selectedPOSCategory && !isCategoryAllowedForDevice(selectedPOSCategory)) {
      dispatch(setSelectedPosCat(null));
    }
  }, [dispatch, isCategoryAllowedForDevice, selectedCategory, selectedPOSCategory]);
  useEffect(() => {
    if (billType === "DELIVERY" && aggregator && filteredCategories?.length === 0) {
      if (aggregator.aggregatorCategoryId?.length > 0) {
        errorSnackMsg("No categories available for this aggregator");
      }
    }
  }, [filteredCategories, billType, aggregator]);


  // console.log('Filtered categories:', filteredCategories);

  const productsForTheme = React.useMemo(() => {
    // Special items and combo offers - NO device restrictions apply
    if (specialItemCat) {
      return (productsList || []);
    }

    const filtered = (productsData || []).filter((product) => {
      // Device restrictions ONLY apply to regular products (not special items)
      const isDeviceRestricted = assignedCategoryIds && assignedCategoryIds.length > 0;
      if (isDeviceRestricted && !isProductAllowedForDevice(product)) {
        return false;
      }
      
      // Then apply user-selected filters
      const matchesCategory = selectedCategory ? product?.mainCatgeoryId === selectedCategory : true;
      const matchesSubCategory = selectedPOSCategory ? product?.poscat === selectedPOSCategory : true;
      
      const matchesSearch = searchBarInput
        ? product?.productName?.toLowerCase().includes(searchBarInput.toLowerCase())
        : true;
      
      return matchesCategory && matchesSubCategory && matchesSearch;
    });

    return filtered;
  }, [
    specialItemCat,
    productsList,
    productsData,
    isProductAllowedForDevice,
    selectedCategory,
    selectedPOSCategory,
    searchBarInput,
    assignedCategoryIds,
  ]);
  const userShiftStatus = localStorage.getItem("shiftStatus");
  const userShiftpk = JSON.parse(userShiftStatus)?._id
  // console.log(checkInDetail?.data?.checkIn);
  localStorage.setItem("userShiftpk", userShiftpk)

  // main category selection
  const categoryOnClick = (id) => () => {

    // Clear special items when selecting a category
    if (specialItemCat !== null) {// added on 27-05-25 by san
      dispatch(setCartProductType(1));
      setSpecialItemCat(null);
    }

    setSelectedCategory(selectedCategory === id ? null : id);
    dispatch(setSelectedPosCat(null));
    dispatch(clearPathData());
    let payload = {
      catId: selectedCategory === id ? undefined : id,
      isPos: true,
      branchId: userBranchId
    };
    getAllSubCatForBilling(payload);
  };

  // pos/sub category select
  const posCategorySelect = (row) => {
    // Clear special items selection when selecting a POS category
    if (specialItemCat !== null) { // added on 27-05-25 by san
      dispatch(setCartProductType(1));
      setSpecialItemCat(null);
      dispatch(setDialogBox(null));
    }

    if (selectedPOSCategory === row?._id) {
      dispatch(setSelectedPosCat(null));
      dispatch(clearPathData());
      // When unselecting, fetch empty subcategories
      getAllSubCatForBilling({
        isPos: true,
        branchId: userBranchId,
        catId: selectedCategory !== null ? selectedCategory : undefined,
        parentCategories: undefined
      });

    } else {
      dispatch(setSelectedPosCat(row?._id));
      dispatch(setArrowPathData(row));
      getAllSubCatForBilling({ // added on 28-05-25 by san
        catId: selectedCategory !== null ? selectedCategory : "",
        isPos: true,
        branchId: userBranchId,
        parentCategories: row?._id,
      });

    }

    // Reset pagination after subcategory change
    dispatch(setPageIndex(0));
    dispatch(setPagination(false));

  };
  // snackbar functions
  const closeSuccessSnackbar = () => {
    setSuccessSnackbar(false)
  }
  const closeErrorSnackbar = () => {
    setErrorSnackbar(false)
  }
  // Toggle special items dropdown for premium theme
  const toggleSpecialItems = () => {
    setSpecialItemsOpen(!specialItemsOpen);
  };

  // Veg/Non-veg filter handler for premium theme
  const handleVegFilterClick = (filter) => {
    if (selectedPIndex === filter) {
      setSelectedPIndex(null);
      categoryListAPICall({ isPos: true, branchId: userBranchId });
    } else {
      setSelectedPIndex(filter);
      categoryListAPICall({
        type: filter === 'veg' ? true : false,
        isPos: true,
        branchId: userBranchId
      });
    }
  };

  // special items and combo offers selection
  const specialItemsClick = (row) => {

    // Clear any category selections when selecting special items
    if (specialItemCat !== row?._id) {  // added on 27-05-25 by san
      setSelectedCategory(null);
      dispatch(setSelectedPosCat(null));
      dispatch(clearPathData());

      // Add this to clear the subcategory list
      getAllSubCatForBilling({
        isPos: true,
        branchId: userBranchId,
        catId: undefined,
        parentCategories: undefined
      });
    }

    if (dialogOpen === "specialOffer") {
      dispatch(setDialogBox(null));
    }

    if (specialItemCat === row?._id) {
      dispatch(setCartProductType(1))
      setSpecialItemCat(null);
      dispatch(setDialogBox(null));

    } else {
      setSpecialItemCat(row?._id);
      dispatch(setDialogBox("specialOffer"));

      if (row?._id === "combo") {
        comboOffersProductsListForBilling(
          { branchId: userBranchId },
          setIsLoading
        );
      } else {
        specialOfferProductsListForBilling(
          {
            id: row?._id,
            branchId: userBranchId,
          },
          setIsLoading
        );
      }
    }
  };
  // console.log(singleOrderInfo);
  

  const transferTableClick = () => {
    dispatch(setBtnSelected("tableChange"))
    if (!(singleOrderInfo?.tableNames.length === 0)) {
      localStorage.setItem("defaultFloorId", singleOrderInfo?.floorId)
    }
  }
  // Function to add a product to the cart
  // const addToCart = (product) => {
  //   // Check if the product is already in the cart based on its id
  //   const existingItemIndex = cartItems.findIndex(
  //     (item) => item._id === product._id
  //   );
  //   if (existingItemIndex !== -1) {
  //     const updatedCartItems = [...cartItems];
  //     let existingQty = updatedCartItems[existingItemIndex].quantity
  //     // If the product is already in the cart, update its quantity
  //     updatedCartItems[existingItemIndex].quantity = Number(existingQty) + 1; // Increase quantity by 1
  //     setCartItems(updatedCartItems);
  //     setSelectedCartRow(existingItemIndex)
  //     keyPadTypeSelection("qty", existingItemIndex);
  //   } else {
  //     setSelectedCartRow(0)
  //     keyPadTypeSelection("qty", 0);
  //     // If the product is not in the cart, add it with a quantity of 1
  //     setCartItems([
  //       { ...product, quantity: 1, itemType: productType }, ...cartItems
  //     ]);
  //   }
  //   setIsCartModified(!isCartModified);
  // };
  const addToCart = async (product) => {
    try {
      // Check if customer selection is mandatory and no customer is selected
      if (customerPaymentStatus && !customer) {
        errorSnackMsg("Please select a customer before adding items to cart!");
        return;
      }
      // Check product stock
      // const stockData = await productStockCheckById({
      //     branchId: userInfo?.branchPk,
      //     productId: product._id || product.id
      // });       
      // if (!stockData || stockData.stock <= 0) {
      //     errorSnackMsg("This product is out of stock!");
      //     return;
      // }

      // Check if the product is already in the cart based on its id
      const existingItemIndex = cartItems.findIndex(
        (item) => item._id === product._id
      );

      if (existingItemIndex !== -1) {
        const updatedCartItems = [...cartItems];
        let existingQty = updatedCartItems[existingItemIndex].quantity;
        // If the product is already in the cart, update its quantity
        updatedCartItems[existingItemIndex].quantity = Number(existingQty) + 1; // Increase quantity by 1
        setCartItems(updatedCartItems);
        setSelectedCartRow(existingItemIndex);
        keyPadTypeSelection("qty", existingItemIndex);
      } else {
        setSelectedCartRow(0);
        keyPadTypeSelection("qty", 0);
        // If the product is not in the cart, add it with a quantity of 1
        setCartItems([
          { 
            ...product, 
            quantity: 1, 
            itemType: productType,
            // Protect against decreasing price: capture the base price at add-time
            minSalesPrice: Number(product?.salesPrice ?? product?.unitPrice ?? 0)
          },
          ...cartItems,
        ]);
      }
      setIsCartModified(!isCartModified);
    } catch (error) {
      errorSnackMsg("Failed to check product availability");
      console.error("Add to cart error:", error);
    }
  };

  // Functions to delete cart item
  const handleDelete = (index) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems.splice(index, 1); // Remove the item at the specified index
    setCartItems(updatedCartItems);
    setIsCartModified(!isCartModified);
  };

  // input the changes of quantity from cart
  const cartQuantityChange = (index, type) => (e) => {
    setInput("");
    const updatedCartItems = [...cartItems];

    // When editing price, enforce noDecreasePrice if enabled
    if (type === "salesPrice" && branchSettingsView?.noDecreasePrice) {
      const base = Number(updatedCartItems[index]?.minSalesPrice ?? updatedCartItems[index]?.salesPrice ?? 0);
      const nextVal = Number(e.target.value);
      updatedCartItems[index].salesPrice = nextVal < base ? base : nextVal;
    } else {
      updatedCartItems[index][type] = Number(e.target.value);
    }
    setCartItems(updatedCartItems);

    setIsCartModified(!isCartModified);
  };
  // add note on cart items
  const cartAddNote = () => {
    // ignore if nothing typed
    const newText = (input || "").toString().replace(/\r\n/g, "\n").trim();
    if (!newText) {
      dispatch(setDialogBox(null));
      setInputSelection(null);
      return;
    }

    const updatedCartItems = [...cartItems];
    const current = (updatedCartItems[selectedCartRow]?.customerNote || "").toString();
    // Append with newline if an existing note is present
    const combined = current ? `${current}\n${newText}` : newText;
    updatedCartItems[selectedCartRow].customerNote = combined;

    setCartItems(updatedCartItems);
    setIsCartModified(!isCartModified);
    dispatch(setDialogBox(null));
    setInputSelection(null);
    setInput("");
  };

  // keypad buttons onChange
  const handleButtonClick = (value) => {
    if (selectedCartRow !== null) {
      setInput((prevInput) => prevInput + value);
      const updatedCartItems = [...cartItems];

      if (inputSelection === "qty") {
        updatedCartItems[selectedCartRow].quantity = Number(input + value);
      } else if (inputSelection === "price") {
        const nextVal = Number(input + value);
        if (branchSettingsView?.noDecreasePrice) {
          const base = Number(updatedCartItems[selectedCartRow]?.minSalesPrice ?? updatedCartItems[selectedCartRow]?.salesPrice ?? 0);
          updatedCartItems[selectedCartRow].salesPrice = nextVal < base ? base : nextVal;
        } else {
          updatedCartItems[selectedCartRow].salesPrice = nextVal;
        }
      }
      setCartItems(updatedCartItems);
      setIsCartModified(!isCartModified);
    }
  };

  // calculate taxes of the cart items
  //////////////////////////////////////correct way/////////////////////////////////////
  // const calculateAndSetCalculatedValues = () => {

  //   const calculatedValues = cartItems?.map((row) => {
  //     let totalAmt = Number(row?.quantity) * Number(row?.salesPrice);
  //     let subtotalBeforeTax = totalAmt?.toFixed(decimalPosition);
  //     let totalTax = row?.taxes?.reduce((sum, item) => sum + item?.amount, 0);
  //     let totalExclTax = (Number(subtotalBeforeTax) * totalTax) / 100;
  //     if (row?.includedPrice === "true" || row?.includedPrice === true) {

  //       let taxesAmount = row?.taxes?.map((obj) => obj?.amount)
  //       let totalInclArr = taxesAmount?.map((item, index) => {
  //         let total = (Number(subtotalBeforeTax) * item) / (100 + item)
  //         return total
  //       }, 0)

  //       let totalIncl = totalInclArr?.reduce((sum, item) => sum + item, 0)
  //       return {
  //         ...row,
  //         inclusiveTax: totalIncl,
  //         exclusiveTax: 0,
  //         subTotalWoTax: totalAmt,
  //         lineTotal: totalAmt,
  //       };
  //     } else if (
  //       row?.includedPrice === "false" ||
  //       row?.includedPrice === false
  //     ) {
  //       return {
  //         ...row,
  //         exclusiveTax: totalExclTax,
  //         inclusiveTax: 0,
  //         subTotalWoTax: totalAmt,
  //         lineTotal: totalAmt + totalExclTax,
  //       };
  //     } else {
  //       return {
  //         ...row,
  //         exclusiveTax: 0,
  //         inclusiveTax: 0,
  //         subTotalWoTax: totalAmt,
  //         lineTotal: totalAmt,
  //       };
  //     }
  //   });
  //   setCartItems(calculatedValues);
  // };
  //////////////////////////////////////////////////////////////////////////////////
  //   const calculateAndSetCalculatedValues = () => {
  //   const calculatedValues = cartItems?.map((row) => {
  //     let totalAmt = Number(row?.quantity) * Number(row?.salesPrice);
  //     let subtotalBeforeTax = totalAmt;
  //     // console.log("subtotalBeforeTax before toFixed:", subtotalBeforeTax);
  //     // subtotalBeforeTax = subtotalBeforeTax?.toFixed(decimalPosition);
  //     // console.log("subtotalBeforeTax", subtotalBeforeTax);

  //     let totalTax = row?.taxes?.reduce((sum, item) => sum + item?.amount, 0);
  //     let totalExclTax = (Number(subtotalBeforeTax) * totalTax) / 100;
  //     console.log("totalTax ", totalTax);


  //     if (row?.includedPrice === "true" || row?.includedPrice === true) {
  //       let taxesAmount = row?.taxes?.map((obj) => obj?.amount)
  //       let totalInclArr = taxesAmount?.map((item, index) => {
  //         let total = (Number(subtotalBeforeTax) * item) / (100 + item)
  //         // console.log("totalInclArr item before toFixed:", total);
  //         // total = total?.toFixed(decimalPosition);
  //         // console.log("total", total);
  //         return total;
  //       }, 0)
  //       let totalIncl = totalInclArr?.reduce((sum, item) => sum + Number(item), 0)
  //       return {
  //         ...row,
  //         inclusiveTax: totalIncl,
  //         exclusiveTax: 0,
  //         subTotalWoTax: totalAmt,
  //         lineTotal: totalAmt,
  //       };
  //     } else if (
  //       row?.includedPrice === "false" ||
  //       row?.includedPrice === false
  //     ) {
  //       // const lineTotal = Number(new Decimal(totalAmt).plus(totalExclTax).toDecimalPlaces(4));
  //       return {
  //         ...row,
  //         exclusiveTax: totalExclTax,
  //         inclusiveTax: 0,
  //         subTotalWoTax: totalAmt,
  //         // lineTotal: lineTotal,
  //         lineTotal: totalAmt + totalExclTax,
  //       };
  //     } else {
  //       return {
  //         ...row,
  //         exclusiveTax: 0,
  //         inclusiveTax: 0,
  //         subTotalWoTax: totalAmt,
  //         lineTotal: totalAmt,
  //       };
  //     }
  //   });
  //   setCartItems(calculatedValues);
  // };
  const calculateAndSetCalculatedValues = () => {
    const calculatedValues = cartItems?.map((row) => {
      const quantity = Number(row?.quantity || 0);
      const salesPrice = Number(row?.salesPrice || 0);
      const totalAmt = quantity * salesPrice;
      const subtotalBeforeTax = totalAmt;

      const taxArray = row?.taxes || [];

      // Inclusive tax logic
      if (row?.includedPrice === "true" || row?.includedPrice === true) {
        const totalInclArr = taxArray.map((tax) => {
          const rate = tax?.amount || 0;
          return (subtotalBeforeTax * rate) / (100 + rate);
        });

        const totalInclusiveTax = totalInclArr.reduce((sum, item) => sum + item, 0);

        return {
          ...row,
          inclusiveTax: totalInclusiveTax,
          exclusiveTax: 0,
          subTotalWoTax: subtotalBeforeTax,
          lineTotal: subtotalBeforeTax,
        };
      }

      // Exclusive tax logic
      if (row?.includedPrice === "false" || row?.includedPrice === false) {
        const totalExclTax = taxArray.reduce((sum, tax) => {
          const rate = tax?.amount || 0;
          // console.log("each Exclusive", subtotalBeforeTax * rate / 100);
          return sum + (subtotalBeforeTax * rate) / 100;
        }, 0);

        const lineTotal = subtotalBeforeTax + totalExclTax;

        return {
          ...row,
          exclusiveTax: totalExclTax,
          inclusiveTax: 0,
          subTotalWoTax: subtotalBeforeTax,
          lineTotal: lineTotal,
        };
      }

      // No tax case
      return {
        ...row,
        exclusiveTax: 0,
        inclusiveTax: 0,
        subTotalWoTax: subtotalBeforeTax,
        lineTotal: subtotalBeforeTax,
      };
    });

    setCartItems(calculatedValues);
  };

  const clearPOSOrder = () => {
    setCartItems([]);
    dispatch(setOrderIdInPOS(null));
    dispatch(setSingleOrderInfo(null));
    dispatch(setCartTOBackend(null));
    // Reset delivery KM when clearing order
    dispatch(setSelfDeliveryKm(0));
    dispatch(setSelfDeliveryCharge(0));
  };

  const generateOrderInfo = (items) => {
    return items?.map((item) => {
      const taxes = item?.taxes || [];
      // If taxes array is empty, includedPrice must be null (backend validation requirement)
      let includedPrice;
      if (taxes.length === 0) {
        includedPrice = null;
      } else if (item?.includedPrice === "true" || item?.includedPrice === true) {
        includedPrice = true;
      } else if (item?.includedPrice === "false" || item?.includedPrice === false) {
        includedPrice = false;
      } else {
        includedPrice = null;
      }
      
      return {
        productId: item?._id,
        desccription: item?.productName,
        customerNote: item?.customerNote || null,
        qty: Number(item?.quantity),
        uom: item?.uom,
        unitPrice: Number(item?.salesPrice),
        subTotalWoTax: item?.subTotalWoTax,
        lineTotal: item?.lineTotal,
        taxes: taxes,
        itemType: item?.itemType,
        includedPrice: includedPrice,
        mainCatgeoryId: item?.mainCatgeoryId || null,
        imageUrl: item?.imageUrl || null,
        ...(item?.itemType === 3 && item?.productList ? { productList: item.productList } : {}),
      };
    });
  };

  const calculateRoundedAmount = (amount) => {
    const rounded = Math.round(amount);
    const roundOffValue = parseFloat((rounded - amount));
    return {
      roundedAmount: rounded,
      roundOffValue: roundOffValue
    };
  };

  // const calculateTotals = (items) => {
  //   const subTotal = items?.reduce((sum, item) => sum + item?.subTotalWoTax, 0);
  //    let amtTotal = items?.reduce((sum, item) => sum + item?.lineTotal, 0);
  //   const exclusive = items?.reduce(
  //     (sum, item) => sum + item?.exclusiveTax,
  //     0
  //   );
  //   const inclusive = items?.reduce(
  //     (sum, item) => sum + item?.inclusiveTax,
  //     0
  //   );
  //   let totalExclusive = Number(exclusive?.toFixed(decimalPosition));
  //   let totalInclusive = Number(inclusive?.toFixed(decimalPosition));

  //    let roundOffValue = 0;
  // console.log(amtTotal,"amtTotalamtTotal")
  // if (roundOff) {
  //   const rounded = calculateRoundedAmount(amtTotal);
  //   amtTotal = rounded.roundedAmount;
  //   roundOffValue = rounded.roundOffValue;
  // }
  //   return { subTotal, amtTotal, totalExclusive, totalInclusive };
  // };


  //////////////////////////////////correct way///////////////////////////
  // const calculateTotals = (items) => {
  //   const subTotal = items?.reduce((sum, item) => sum + item?.subTotalWoTax, 0);
  //   let amtTotal = items?.reduce((sum, item) => sum + item?.lineTotal, 0);
  //   const exclusive = items?.reduce(
  //     (sum, item) => sum + item?.exclusiveTax,
  //     0
  //   );
  //   const inclusive = items?.reduce(
  //     (sum, item) => sum + item?.inclusiveTax,
  //     0
  //   );
  //   let totalExclusive = Number(exclusive?.toFixed(decimalPosition));
  //   let totalInclusive = Number(inclusive?.toFixed(decimalPosition));
  //   let roundOffValue = 0;
  //   console.log(amtTotal, "amtTotalbefore")
  //   if (roundOff) {
  //     const rounded = calculateRoundedAmount(amtTotal);
  //     amtTotal = rounded.roundedAmount;
  //     roundOffValue = rounded.roundOffValue;
  //   }

  //   return {
  //     subTotal,
  //     amtTotal,
  //     totalExclusive,
  //     totalInclusive,
  //     roundOffValue
  //   };
  // };

  //////////////////////////////////////////////////////////////////
  // final post api call
  // const finalPlaceOrder = (orderType) => () => {

  //   // Check if it's a delivery order and no aggregator is selected
  //   if (billType === "DELIVERY" && !aggregator) {// added on san 4/6/25
  //     errorSnackMsg("Delivery partner not selected");
  //     return;
  //   }

  //   const orderInfo = generateOrderInfo(cartItems);
  //   const { subTotal, amtTotal, totalExclusive, totalInclusive,
  //     roundOffValue
  //   } =
  //     calculateTotals(cartItems);
  //   console.log(amtTotal, "amtTotalafter")
  //   let payload = {
  //     orderInfo: orderInfo,
  //     subTotal,
  //     discountAmt: 0,
  //     amtTotal,
  //     totalInclusive,
  //     totalExclusive,
  //     branchId: userBranchId,
  //     cusId: customer?._id || defaultCustomer?._id,
  //     waiterId: waiter?._id || null,
  //     aggregatorId: billType === "DELIVERY" ? aggregator?._id || null : null,
  //     aggregatorRef: billType === "DELIVERY" ? aggregatorRef : null,
  //     roundOff: roundOff ? roundOffValue : 0
  //   };
  //   if (orderIdForPos === null) {
  //     payload.orderDate = `${today} ${getCurrentTime()}`;
  //     payload.ordType = billType;
  //   } else {
  //     payload.orderId = orderIdForPos;
  //   }

  //   let clearFn = () => {
  //     setCartItems([]);
  //     dispatch(setCustomer(null))
  //     // listHeldOrders({ branchId: userBranchId, type: 1 });
  //   };

  //   // updating an existing order case
  //   if (singleOrderInfo?.status === "DRAFT") {
  //     const updatedOrderInfo = cartItems?.map((item) => ({
  //       productId: item?._id,
  //       desccription: item?.productName,
  //       customerNote: item?.customerNote || null,
  //       qty: Number(item?.quantity),
  //       uom: item?.uom,
  //       unitPrice: item?.salesPrice,
  //       subTotalWoTax: item?.subTotalWoTax,
  //       lineTotal: Number(item?.lineTotal),
  //       taxes: item?.taxes,
  //       kotOrderId: item?.kotOrderId || null,
  //       kotStatus: item?.kotStatus || "DRAFT",
  //       includedPrice:
  //         item?.includedPrice === "true" || item?.includedPrice === true
  //           ? true
  //           : item?.includedPrice === "false" || item?.includedPrice === false
  //             ? false
  //             : null,
  //       objType:
  //         item?.quantity > item?.lastQty
  //           ? "add"
  //           : item?.quantity < item?.lastQty
  //             ? "min"
  //             : "eq",
  //       _id: item?.existingId,
  //       itemType: item?.itemType || 1,
  //     }));
  //     let updatedOrderPayload = {
  //       orderId: orderIdForPos,
  //       orderInfo: updatedOrderInfo,
  //       subTotal,
  //       discountAmt: 0,  
  //       totalExclusive,
  //       totalInclusive,
  //       amtTotal,
  //       branchId: userBranchId,
  //       aggregatorId: billType === "DELIVERY" ? aggregator?._id || null : null,
  //       aggregatorName: billType === "DELIVERY" ? aggregator?.name || '' : '',
  //       aggregatorRef: billType === "DELIVERY" ? aggregatorRef : null,
  //       cusId: customer?._id || defaultCustomer?._id,
  //       waiterId: waiter?._id || null,
  //       ordType: billType,
  //       password: authPassWord,
  //       roundOff: roundOff ? roundOffValue : 0
  //     };
  //     let isOrderNotUpdated = areArraysEqual(cartItems, duplicateCartArray);
  //     if (isOrderNotUpdated) {
  //       dispatch(setBtnSelected("payment"));
  //       dispatch(setDialogBox(null));
  //     } else {
  //       if (dialogOpen === "authPassword" || dialogOpen === "authPasswordPayment" || !(branchConfigurationList?.updateOrdAuth)) {
  //         // updatePosOrderAPICall(updatedOrderPayload, clearFn, orderType, kotPrintClick);
  //         // / Add skipKotPrint flag when updating existing order
  //         updatePosOrderAPICall(updatedOrderPayload, clearFn, orderType, (info) => {
  //           // Skip KOT printing for order updates
  //           if (orderType !== "OrderWoPayment") {
  //             kotPrintClick(info);
  //           }
  //         });
  //       } else {
  //         // dispatch(setDialogBox(orderType === "paymentOrder" ? "authPasswordPayment" : "authPassword"))
  //         payload.orderDate = `${today} ${getCurrentTime()}`;
  //         addPOSOrdertoKOT(payload, clearFn, orderType, (info) => {
  //           // Only print KOT if not coming from "Confirm" button
  //           if (orderType !== "OrderWoPayment") {
  //             kotPrintClick(info);
  //           }
  //         });
  //       }
  //     }
  //   } else {
  //     // api call
  //     if (orderIdForPos === null) {
  //       // add order directly without selecting table and chair
  //       addPOSOrderWoFloorSelectionAPI(payload, clearFn, orderType, kotPrintClick);

  //     } else {
  //       payload.orderDate = `${today} ${getCurrentTime()}`;
  //       // add order to the selected table and chair
  //       addPOSOrdertoKOT(payload, clearFn, orderType, kotPrintClick);
  //     }
  //   }


  // };
  const calculateTotals = (items) => {
    const subTotal = items?.reduce((sum, item) => sum + item?.subTotalWoTax, 0);
    let amtTotal = items?.reduce((sum, item) => sum + item?.lineTotal, 0);
    const exclusive = items?.reduce(
      (sum, item) => sum + item?.exclusiveTax,
      0
    );
    const inclusive = items?.reduce(
      (sum, item) => sum + item?.inclusiveTax,
      0
    );
    // console.log("exclusive before toFixed:", exclusive);
    // const totalExclusive = Number(new Decimal(exclusive).toDecimalPlaces(4));
    let totalExclusive = Number(exclusive);
    // console.log("totalExclusive ", totalExclusive);

    // console.log("inclusive before toFixed:", inclusive);
    let totalInclusive = Number(inclusive);

    //  console.log("totalInclusive", totalInclusive);                      
    // console.log("amtTotal :", amtTotal);
    // console.log("subTotal :", subTotal);

    let roundOffValue = 0;
    if (roundOff) {
      const rounded = calculateRoundedAmount(amtTotal);
      amtTotal = rounded.roundedAmount;
      roundOffValue = rounded.roundOffValue;
    }

    return {
      subTotal,
      amtTotal,
      totalExclusive,
      totalInclusive,
      roundOffValue
    };
  };
  const finalPlaceOrder = (orderType) => () => {
    console.log(branchConfigurationList, "branchConfigurationList in billing new")
    
    // Validate branchId before proceeding
    if (!userBranchId) {
      console.error('❌ No branchId available:', { userBranchId, userInfo });
      errorSnackMsg("Branch not configured. Please re-login.");
      return;
    }
    
    // Validate customer - cusId is required by backend
    const resolvedCusId = customer?._id || defaultCustomer?._id;
    if (!resolvedCusId) {
      console.error('❌ No cusId available - defaultCustomer may not have loaded (offline?)');
      errorSnackMsg("Customer data not loaded yet. Please wait a moment and try again.");
      // Proactively re-fetch default customer
      defaultCustomerForPOSAPI({});
      return;
    }

    // Delivery validation check - Aggregator is REQUIRED for delivery
    if (billType === "DELIVERY" && !aggregator) {
      errorSnackMsg("Delivery partner not selected");
      return;
    }

    const orderInfo = generateOrderInfo(cartItems);
    const { subTotal, amtTotal, totalExclusive, totalInclusive, roundOffValue } = calculateTotals(cartItems);
    // console.log("amtTotal after rounding:", amtTotal);
    let payload = {
      orderInfo: orderInfo,
      subTotal,
      discountAmt: 0,
      amtTotal,
      totalInclusive,
      totalExclusive,
      branchId: userBranchId,
      cusId: resolvedCusId,
      customerName: customer?.name || defaultCustomer?.name || 'cash customer',
      customerMobile: customer?.mobileNo || defaultCustomer?.mobileNo || '',
      custAddress: customer?.address || defaultCustomer?.address || {},
      waiterId: waiter?._id || null,
      waiterName: waiter?.name || '-NIL-',
      aggregatorId: billType === "DELIVERY" ? aggregator?._id || null : null,
      aggregatorName: billType === "DELIVERY" ? aggregator?.name || '' : '',
      aggregatorRef: billType === "DELIVERY" ? aggregatorRef : null,
      roundOff: roundOff ? roundOffValue : 0,
      deliveryCharge: billType === "DELIVERY" ? (selfDeliveryCharge || 0) : 0,
      selfDeliveryKm: billType === "DELIVERY" ? (selfDeliveryKm || 0) : 0,
      deliveryBoyId: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?._id : null,
      deliveryBoyName: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?.staff_name : null,
      // POS device binding
      deviceId: assignedDevice?._id || null,
      deviceName: assignedDevice?.deviceName || assignedDevice?.name || null,
      assignedEmployeeId: assignedEmployeeSnapshot.assignedEmployeeId,
      assignedEmployeeName: assignedEmployeeSnapshot.assignedEmployeeName,
      assignedCategoryIds: assignedCategoryIds || [],
      assignedCategoryNames: (assignedDevice?.assignedCategories || []).map((cat) => cat?.categoryName).filter(Boolean),
      deviceAssignedEmployees: assignedDevice?.assignedEmployees || [],
      deviceAssignedCategories: assignedDevice?.assignedCategories || [],
    };

    console.log('🚀 ORDER PAYLOAD DEBUG:', {
      billType,
      branchId: userBranchId,
      cusId: payload.cusId,
      aggregatorIsSelf: aggregator?.isSelf,
      selfDeliveryCharge,
      selfDeliveryKm,
      payloadDeliveryCharge: payload.deliveryCharge,
      payloadSelfDeliveryKm: payload.selfDeliveryKm,
      orderInfoLength: payload.orderInfo?.length
    });

    if (orderIdForPos === null) {
      payload.orderDate = `${today} ${getCurrentTime()}`;
      payload.ordType = billType;  // Always use billType (DELIVERY stays as DELIVERY)
    } else {
      payload.orderId = orderIdForPos;
    }

    const clearFn = () => {
      setCartItems([]);
      dispatch(setCustomer(null));
      // Only reset delivery KM if NOT going to payment (direct payment needs KM preserved)
      if (orderType !== "paymentOrder") {
        dispatch(setSelfDeliveryKm(0));
        dispatch(setSelfDeliveryCharge(0));
      }
    };

    // const sendWhatsAppOnOrder = async () => {
    //   if (!branchConfigurationList?.enableWhatsApp) return;

    //   let config = null;
    //   let phoneNumber = customer?.phoneNumber || "";
    //   let message = "";
    //   let send = false;

    //   if (billType === "DINEIN") {
    //     config = branchConfigurationList?.whatsAppBilling?.dineIn;
    //     if (config?.orderCreated) {
    //       send = true;
    //       message = `Your Dine-In order has been placed. Order No: ${singleOrderInfo?.name || ""}`;
    //     }
    //   } else if (billType === "DELIVERY") {
    //     config = branchConfigurationList?.whatsAppBilling?.delivery;
    //     if (config?.orderCreated) {
    //       send = true;
    //       message = `Your Delivery order has been placed. Order No: ${singleOrderInfo?.name || ""}`;
    //     }
    //   } else if (billType === "TAKEAWAY") {
    //     config = branchConfigurationList?.whatsAppBilling?.takeAway;
    //     if (config?.orderCreated) {
    //       send = true;
    //       message = `Your Takeaway order has been placed. Order No: ${singleOrderInfo?.name || ""}`;
    //     }
    //   }

    //   if (send && phoneNumber) {
    //     const formData = new FormData();
    //     formData.append("userId", userBranchId); // or employeeId if required
    //     formData.append("phoneNumber", phoneNumber);
    //     formData.append("message", message);
    //     try {
    //       await sendWhatsAppMessageAPI(formData, () => { }, () => { });
    //     } catch (err) {
    //       console.error("WhatsApp message send failed", err);
    //     }
    //   }
    // };

    const sendKotPdfToWhatsApp = async () => {
      // console.log("sendKotPdfToWhatsApp called");
      // WhatsApp billing is now handled centrally in the backend; disable old frontend send.
      return;
    };

    // CASE 1: Updating an existing DRAFT order
    if (singleOrderInfo?.status === "DRAFT") {
      const updatedOrderInfo = cartItems.map((item) => ({
        productId: item._id,
        desccription: item.productName,
        customerNote: item.customerNote || null,
        qty: Number(item.quantity),
        uom: item.uom,
        unitPrice: item.salesPrice,
        subTotalWoTax: item.subTotalWoTax,
        lineTotal: Number(item.lineTotal),
        taxes: item.taxes,
        kotOrderId: item.kotOrderId || null,
        kotStatus: item.kotStatus || "DRAFT",
        includedPrice:
          item.includedPrice === "true" || item.includedPrice === true
            ? true
            : item.includedPrice === "false" || item.includedPrice === false
              ? false
              : null,
        objType:
          item.quantity > item.lastQty ? "add" :
            item.quantity < item.lastQty ? "min" : "eq",
        _id: item.existingId,
        itemType: item.itemType || 1,
      }));

      const updatedOrderPayload = {
        orderId: orderIdForPos,
        orderInfo: updatedOrderInfo,
        subTotal,
        discountAmt: 0,
        totalExclusive,
        totalInclusive,
        amtTotal,
        branchId: userBranchId,
        aggregatorId: billType === "DELIVERY" ? aggregator?._id || null : null,
        aggregatorName: billType === "DELIVERY" ? aggregator?.name || '' : '',
        aggregatorRef: billType === "DELIVERY" ? aggregatorRef : null,
        cusId: resolvedCusId,
        customerName: customer?.name || defaultCustomer?.name || 'cash customer',
        customerMobile: customer?.mobileNo || defaultCustomer?.mobileNo || '',
        custAddress: customer?.address || defaultCustomer?.address || {},
        waiterId: waiter?._id || null,
        waiterName: waiter?.name || '-NIL-',
        ordType: billType,
        password: authPassWord,
        roundOff: roundOff ? roundOffValue : 0,
        deliveryCharge: billType === "DELIVERY" ? (selfDeliveryCharge || 0) : 0,
        selfDeliveryKm: billType === "DELIVERY" ? (selfDeliveryKm || 0) : 0,
        deliveryBoyId: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?._id : null,
        deliveryBoyName: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?.staff_name : null,
        // POS device binding
        deviceId: assignedDevice?._id || null,
        deviceName: assignedDevice?.deviceName || assignedDevice?.name || null,
        assignedEmployeeId: assignedEmployeeSnapshot.assignedEmployeeId,
        assignedEmployeeName: assignedEmployeeSnapshot.assignedEmployeeName,
        assignedCategoryIds: assignedCategoryIds || [],
        assignedCategoryNames: (assignedDevice?.assignedCategories || []).map((cat) => cat?.categoryName).filter(Boolean),
        deviceAssignedEmployees: assignedDevice?.assignedEmployees || [],
        deviceAssignedCategories: assignedDevice?.assignedCategories || [],
      };

      const isOrderNotUpdated = areArraysEqual(cartItems, duplicateCartArray);

      if (isOrderNotUpdated) {
        dispatch(setBtnSelected("payment"));
        dispatch(setDialogBox(null));
      } else {
        // if (dialogOpen === "authPassword" || dialogOpen === "authPasswordPayment" || !branchConfigurationList?.updateOrdAuth) {
        //   updatePosOrderAPICall(updatedOrderPayload, clearFn, orderType, (info) => {
        //     if (orderType !== "OrderWoPayment") {
        //       kotPrintClick(info);
        //     }
        //   });
        // } 
        if (dialogOpen === "authPassword" || dialogOpen === "authPasswordPayment" || !branchConfigurationList?.updateOrdAuth) {
          updatePosOrderAPICall(updatedOrderPayload, async () => {
            clearFn();
            await sendKotPdfToWhatsApp();
          }, orderType, (info) => {
            kotPrintClick(info);
          });
        }
        else {
          dispatch(setDialogBox(orderType === "paymentOrder" ? "authPasswordPayment" : "authPassword"));
        }
      }
    }
    // CASE 2: New order without table selection
    // else if (orderIdForPos === null) {
    //   addPOSOrderWoFloorSelectionAPI(payload, clearFn, orderType, kotPrintClick);
    // } 
   else if (orderIdForPos === null) {
  const localClearFn = () => {
    setCartItems([]);
    dispatch(setCustomer(null));
    // Only reset delivery KM if NOT going to payment (direct payment needs KM preserved)
    if (orderType !== "paymentOrder") {
      dispatch(setSelfDeliveryKm(0));
      dispatch(setSelfDeliveryCharge(0));
    }
  };
  addPOSOrderWoFloorSelectionAPI(payload, localClearFn, orderType, kotPrintClick)
    .then(async () => {
      await sendKotPdfToWhatsApp();
    });
}
    // CASE 3: Adding order to selected table (new or existing)
    // else {
    //   payload.orderDate = `${today} ${getCurrentTime()}`;
    //   addPOSOrdertoKOT(payload, clearFn, orderType, kotPrintClick);
    // }
    // else {
    //   payload.orderDate = `${today} ${getCurrentTime()}`;
    //   addPOSOrdertoKOT(payload, async () => {
    //     clearFn();
    //     await sendKotPdfToWhatsApp(); // <-- Call here
    //   }, orderType, kotPrintClick);
    // }

    else {
  payload.orderDate = `${today} ${getCurrentTime()}`;
  const localClearFn = () => {
    setCartItems([]);
    dispatch(setCustomer(null));
    // Only reset delivery KM if NOT going to payment (direct payment needs KM preserved)
    if (orderType !== "paymentOrder") {
      dispatch(setSelfDeliveryKm(0));
      dispatch(setSelfDeliveryCharge(0));
    }
  };
  addPOSOrdertoKOT(payload, localClearFn, orderType, kotPrintClick)
    .then(async () => {
      await sendKotPdfToWhatsApp();
    });
}
  };

  const quickBillOrder = () => {
    const quickCusId = customer?._id || defaultCustomer?._id;
    if (!quickCusId) {
      errorSnackMsg("Customer data not loaded yet. Please wait a moment and try again.");
      defaultCustomerForPOSAPI({});
      return;
    }

    // Check if it's a delivery order and no aggregator is selected
    if (billType === "DELIVERY" && !aggregator) {
      errorSnackMsg("Delivery partner not selected");
      return;
    }

    const orderInfo = generateOrderInfo(cartItems);
    const { subTotal, amtTotal, totalExclusive, totalInclusive,
      roundOffValue
    } =
      calculateTotals(cartItems);

    let payload = {
      _id: orderIdForPos,
      orderInfo: orderInfo,
      subTotal,
      discountAmt: 0,
      amtTotal,
      totalInclusive,
      totalExclusive,
      branchId: userBranchId,
      cusId: quickCusId,
      customerName: customer?.name || defaultCustomer?.name || 'cash customer',
      customerMobile: customer?.mobileNo || defaultCustomer?.mobileNo || '',
      custAddress: customer?.address || defaultCustomer?.address || {},
      waiterId: waiter?._id || null,
      waiterName: waiter?.name || '-NIL-',
      aggregatorId: billType === "DELIVERY" ? aggregator?._id || null : null,
      aggregatorName: billType === "DELIVERY" ? aggregator?.name || '' : '',
      aggregatorRef: billType === "DELIVERY" ? aggregatorRef : null,
      orderDate: `${today} ${getCurrentTime()}`,
      ordType: billType,
      roundOff: roundOff ? roundOffValue : 0,
      deliveryCharge: billType === "DELIVERY" ? (selfDeliveryCharge || 0) : 0,
      selfDeliveryKm: billType === "DELIVERY" ? (selfDeliveryKm || 0) : 0,
      deliveryBoyId: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?._id : null,
      deliveryBoyName: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?.staff_name : null
    };
    let clearFn = () => {
      setCartItems([]);
      dispatch(setBtnSelected("payment"))
      // Don't reset KM here - user is going to payment, may need it for receipt
    };
    // quick bill add api call
    quickBillOrderAPI(payload, clearFn)

  };

  // keypad hold button click
  const holdOrderClick = () => {
    const holdCusId = customer?._id || defaultCustomer?._id;
    if (!holdCusId) {
      errorSnackMsg("Customer data not loaded yet. Please wait a moment and try again.");
      defaultCustomerForPOSAPI({});
      return;
    }

    const orderInfo = generateOrderInfo(cartItems);
    const { subTotal, amtTotal, totalExclusive, totalInclusive,
      roundOffValue
    } =
      calculateTotals(cartItems);

    let payload = {
      orderId: singleOrderInfo?._id || null,
      orderInfo: orderInfo,
      subTotal,
      discountAmt: 0,
      amtTotal,
      totalInclusive,
      totalExclusive,
      branchId: userBranchId,
      cusId: holdCusId,
      customerName: customer?.name || defaultCustomer?.name || 'cash customer',
      customerMobile: customer?.mobileNo || defaultCustomer?.mobileNo || '',
      custAddress: customer?.address || defaultCustomer?.address || {},
      orderDate: `${today} ${getCurrentTime()}`,
      ordType: billType,
      aggregatorId: billType === "DELIVERY" ? aggregator?._id || null : null,
      aggregatorName: billType === "DELIVERY" ? aggregator?.name || '' : '',
      aggregatorRef: billType === "DELIVERY" ? aggregatorRef : null,
      waiterId: waiter?._id || null,
      waiterName: waiter?.name || '-NIL-',
      roundOff: roundOff ? roundOffValue : 0,
      deliveryCharge: billType === "DELIVERY" ? (selfDeliveryCharge || 0) : 0,
      selfDeliveryKm: billType === "DELIVERY" ? (selfDeliveryKm || 0) : 0,
      deliveryBoyId: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?._id : null,
      deliveryBoyName: billType === "DELIVERY" && deliveryBoy ? deliveryBoy?.staff_name : null
    };
    let clearFn = () => {
      setCartItems([]);
      dispatch(setCustomer(null));
      // Reset delivery KM for next order
      dispatch(setSelfDeliveryKm(0));
      dispatch(setSelfDeliveryCharge(0));
    };
    holdPOSOrderAPI(payload, clearFn);
  };
  // select cart action price || note || qty
  const keyPadTypeSelection = (key, index) => {
    setInput("");
    setInputSelection(key);
    const inputRef =
      key === "qty"
        ? qtyInputRefs.current[index || selectedCartRow]
        : key === "price"
          ? salesPriceRefs.current[selectedCartRow]
          : null;

    if (inputRef && inputRef.current) {
      const originalType = inputRef.current.type;
      inputRef.current.type = "text";

      inputRef.current.focus();

      setTimeout(() => {
        if (inputRef.current) {
          try {
            inputRef.current.setSelectionRange(
              inputRef.current.value.length,
              inputRef.current.value.length
            );
          } catch (e) {
            // number inputs don't support setSelectionRange
          }
          inputRef.current.type = originalType;
        }
      }, 0);
    }

    if (key === "note") {
      setInput(cartItems[selectedCartRow]?.customerNote || "")
      dispatch(setDialogBox("addNote"));
    }

    handleMouseEnter()
  };
  // cart row
  const cartRowClick = (index) => () => {
    handleMouseEnter()
    setSelectedCartRow(index === selectedCartRow ? null : index);
    if (index === selectedCartRow) {
      setInputSelection(null);
    } else {
      keyPadTypeSelection("qty", index);
    }
  };

  const handleMouseEnter = () => {
    const updatedArray = roundNumericFields(cartItems, ["quantity", "salesPrice"]);
    setCartItems(updatedArray);
    setIsCartModified(!isCartModified)
  }

  const searchInputOnChange = (value) => {
    dispatch(setSearchBarInput(value))
  }
  // <--------send-to-ws--btn-action------>

  // const sendMessageToWs = async () => {
  //   try {
  //     // Convert to PDF 
  //     const content = invoicePrint.current;

  //     const options = {
  //       filename: 'sample.pdf',
  //       image: { type: 'jpeg', quality: 1 }, 
  //       html2canvas: { scale: 2, logging: false }, 
  //       jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  //     };

  //     // Generate PDF
  //     const pdfBlob = await html2pdf().from(content).set(options).outputPdf('blob');

  //     // Create FormData object and append the PDF file
  //     const formData = new FormData();
  //     formData.append('pdfFile', pdfBlob, 'sample.pdf');
  //     formData.append('_id',receiptData?._id );
  //     formData.append('type',"POS" );

  //     // Now you can pass formData to your API




  //     const response = await sendMessageToWhatsApp(formData) 






  //   } catch (error) {
  //     console.log("Error sending message:", error);
  //     // Handle error if required
  //   }
  // }
  const handlePrintKot = useReactToPrint({
    content: () => kotPrintRef.current,
  })

  // Helper: filter orderInfo items based on KOT printer's product filter
  const filterKotOrderInfo = (orderInfo, filterProductIds) => {
    if (!filterProductIds || filterProductIds.length === 0) return orderInfo;
    const idSet = new Set(filterProductIds);
    return (orderInfo || []).filter(item => idSet.has(item?.productId));
  };

  // Helper: expand orderInfo items to their recipe raw materials
  const expandToRawMaterials = (orderInfo, rawMaterialEnabled) => {
    if (!rawMaterialEnabled || !recipeMapRef.current) {
      console.log('🔧 expandToRawMaterials skipped:', { rawMaterialEnabled, hasRecipeMap: !!recipeMapRef.current });
      return orderInfo;
    }
    console.log('🔧 expandToRawMaterials: expanding', orderInfo?.length, 'items');
    const expanded = [];
    for (const item of (orderInfo || [])) {
      const components = recipeMapRef.current[item?.productId];
      console.log('🔧 Product:', item?.productId, item?.desccription || item?.productName, '→ components:', components?.length || 0);
      if (components && components.length > 0) {
        const orderedQty = Number(item?.qty) || 1;
        for (const comp of components) {
          expanded.push({
            ...item,
            productId: comp.productId,
            productName: comp.productName || comp.productId,
            desccription: comp.productName || comp.productId,
            qty: Number((comp.quantity * orderedQty).toFixed(4)),
            uom: comp.uomName || comp.uom || item?.uom,
            _isRawMaterial: true,
            _parentProduct: item?.desccription || item?.productName,
          });
        }
      } else {
        expanded.push(item);
      }
    }
    return expanded;
  };

  // Helper: KOT print with Socket Print priority, fallback to thermal utility
  const smartKotPrint = async (payload, fallbackFn) => {
    let ps = JSON.parse(localStorage.getItem('PrinterSettings') || '{}');
    if (ps?.useSocketPrint && payload?.printerName) {
      try {
        const { socketKotThermalPrint } = await import('../../Settings/Device Settings/socketPrintService');
        await socketKotThermalPrint(payload);
        // Socket print succeeded - do NOT open browser print dialog
        return;
      } catch (err) {
        console.error('Socket KOT print failed, falling back:', err);
      }
    }
    kotPrintRequestAPICall(payload, fallbackFn);
  };

  const kotPrintClick = async (info) => {
    console.log('kotPrintClick called with info:', info);
    console.log('kotPrintClick orderInfo:', info?.orderInfo);
    
    // Ensure Redux kotSingleData is updated with fresh info before any print attempt
    // This is critical because browser print fallback reads from kotSingleData via kotPrintRef
    if (info) {
      dispatch(setKOTSingleInfo(info));
      // Allow React to re-render KotPrint component with new data before printing
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    
    dispatch(setBillLoading(true))
    try {
      let printSettingsString = localStorage.getItem('PrinterSettings')
      let printSettings = JSON.parse(printSettingsString)

      // Filter orderInfo for main KOT printer based on filter settings
      const mainFilteredOrderInfo = expandToRawMaterials(
        filterKotOrderInfo(info?.orderInfo, printSettings?.kotFilterProductIds),
        printSettings?.kotRawMaterial
      );
      const mainKotHasItems = mainFilteredOrderInfo && mainFilteredOrderInfo.length > 0;

      let payload = {
        printerWidth: printSettings?.kotSize === "80" ? 48 : 32,
        printerName: printSettings?.kotPrinter,
        enableNativeName: printSettings?.enableKotNativeName || false,
        transNo: info?.transNo,
        ordName: info?.ordName,
        orderDate: info?.orderDate,
        ordType: info?.ordType,
        waiterName: info?.waiterName || "-NIL-",
        orderInfo: mainFilteredOrderInfo,
        tables: info?.tables,
        floorName: info?.floorName,
        kotPrintNotes: printSettings?.kotPrintNotes || false,
      }
      console.log('KOT Print Payload:', payload);
      
      // Close dialogs after a small delay to ensure print component renders
      setTimeout(() => {
        dispatch(setDialogBox(null))
        dispatch(setKOTManualDialog(null))
      }, 100);
      
      if (!printSettings?.enableKotPrintAfterPayment) {
        // Print main KOT only if there are matching items after filtering
        if (mainKotHasItems) {
          // Check if QZ Tray is enabled
          if (printSettings?.useBrowserPrint && printSettings?.kotPrinter) {
            // Try QZ Tray first
            console.log('Trying QZ Tray for manual KOT print...');
            const qzAvailable = await isQzTrayAvailable();
            if (qzAvailable) {
              const kotWidth = printSettings?.kotSize === '80' ? 72 : 48;
              const success = await qzTrayKotPrintAPICall(printSettings.kotPrinter, payload, { width: kotWidth });
              if (!success) {
                // QZ Tray failed, fall back to browser print
                console.log('QZ Tray KOT failed, falling back to browser print...');
                handlePrintKot();
              }
            } else {
              // QZ Tray not available, try thermal utility then browser print
              console.log('QZ Tray not available, trying thermal utility for KOT...');
              smartKotPrint(payload, handlePrintKot);
            }
          } else if (printSettings?.kotPrinter) {
            // Thermal utility mode - try thermal, fallback to browser print
            console.log('Using thermal print utility for KOT...');
            smartKotPrint(payload, handlePrintKot);
          } else {
            // No printer configured - use browser print
            console.log('Using browser print for KOT...');
            handlePrintKot();
          }
        }

        // ========== ADDITIONAL KOT PRINTERS - Manual KOT print ==========
        const additionalKotPrinters = printSettings?.additionalKotPrinters || [];
        for (const additionalKot of additionalKotPrinters) {
          // Check if this additional KOT printer has auto enabled (for manual KOT print)
          if (additionalKot?.printer && additionalKot?.auto && !additionalKot?.enableKotPrintAfterPayment) {
            console.log(`🖨️ Additional KOT Printer [${additionalKot.areaName}] - manual KOT print...`);
            
            // Filter orderInfo for this additional KOT printer
            const additionalFilteredOrderInfo = expandToRawMaterials(
              filterKotOrderInfo(info?.orderInfo, additionalKot?.kotFilterProductIds),
              additionalKot?.kotRawMaterial
            );
            if (additionalFilteredOrderInfo.length === 0) continue; // Skip if no matching items

            const additionalKotPayload = {
              printerWidth: additionalKot?.size === "80" ? 48 : 32,
              printerName: additionalKot.printer,
              enableNativeName: additionalKot?.enableNativeName || false,
              transNo: info?.transNo,
              ordName: info?.ordName,
              orderDate: info?.orderDate,
              ordType: info?.ordType,
              waiterName: info?.waiterName || "-NIL-",
              orderInfo: additionalFilteredOrderInfo,
              tables: info?.tables,
              floorName: info?.floorName,
              areaName: additionalKot.areaName,
              kotPrintNotes: additionalKot?.kotPrintNotes || false,
            };

            if (printSettings?.useBrowserPrint && additionalKot.printer) {
              const qzAvailable = await isQzTrayAvailable();
              if (qzAvailable) {
                const kotWidth = additionalKot?.size === '80' ? 72 : 48;
                await qzTrayKotPrintAPICall(additionalKot.printer, additionalKotPayload, { width: kotWidth });
              } else {
                smartKotPrint(additionalKotPayload, handlePrintKot);
              }
            } else if (additionalKot.printer) {
              smartKotPrint(additionalKotPayload, handlePrintKot);
            }
          }
        }
      }

      if (printSettings?.kotAuto && // added on san 4/6/25
        printSettings?.enableKotPrintAfterPayment
        //  &&
        // receiptData?.ordType === "DINEIN" // upated on san 11/6/25

      ) {
        console.log('Triggering KOT print before payment (kotAuto enabled)...');

        for (const kot of receiptData.kotData) {
          // Filter orderInfo for main KOT printer
          const kotFilteredOrderInfo = expandToRawMaterials(
            filterKotOrderInfo(kot.orderInfo || receiptData?.orderInfo, printSettings?.kotFilterProductIds),
            printSettings?.kotRawMaterial
          );
          if (kotFilteredOrderInfo.length === 0) continue; // Skip if no matching items

          const kotPayload = {
            printerWidth: printSettings?.kotSize === "80" ? 48 : 32,
            printerName: printSettings?.kotPrinter || printSettings?.kotPrinter,
            enableNativeName: printSettings?.enableKotNativeName || false,
            transNo: kot.name || receiptData?.name,
            ordName: kot.ordName || receiptData?.ordName,
            orderDate: kot.orderDate || receiptData?.orderDate,
            ordType: kot.ordType || receiptData?.ordType,
            waiterName: kot.waiterName || receiptData?.waiterName || "-NIL-",
            orderInfo: kotFilteredOrderInfo,
            tables: kot.tables || receiptData?.tables,
            floorName: kot.floorName || receiptData?.floorName,
            kotPrintNotes: printSettings?.kotPrintNotes || false,
          };

          // Priority: Printer selection > Browser print > Manual print
          if (printSettings?.kotPrinter) {
            smartKotPrint(kotPayload, handlePrintKot);
          } else if (printSettings?.useBrowserPrint) {
            handlePrintKot(); // browser default
          } else {
            handlePrintKot(); // fallback
          }
        }
      }

    } catch (error) {
      dispatch(setBillLoading(false))
    } finally {
      dispatch(setBillLoading(false));
    }

  }

  const posReceiptPrint = async () => {
    if (!invoicePrint.current) return;

    // Ensure content exists
    let tries = 0;
    while (tries < 20) {
      const node = invoicePrint.current?.querySelector('.pos-receipt-template-container');
      if (node) break;
      await new Promise(r => setTimeout(r, 100));
      tries++;
    }

    // Temporarily reveal container to avoid zero-size capture while preserving width
    const printParent = invoicePrint.current?.closest('.print-parent');
    const prev = printParent ? {
      position: printParent.style.position,
      top: printParent.style.top,
      left: printParent.style.left,
      width: printParent.style.width,
      maxHeight: printParent.style.maxHeight,
      overflow: printParent.style.overflow,
      opacity: printParent.style.opacity,
      zIndex: printParent.style.zIndex,
    } : null;
    if (printParent) {
      printParent.style.position = 'absolute';
      printParent.style.top = '0';
      printParent.style.left = '-9999px';
      // Do not change width; preserve receipt width (58/80mm)
      printParent.style.maxHeight = 'none';
      printParent.style.overflow = 'visible';
      printParent.style.opacity = '1';
      printParent.style.zIndex = 'auto';
    }

    // Compute dynamic height for jsPDF
    const receiptHTML = invoicePrint.current;
    // Wait for images (logo) to load to avoid missing logo in PDF
    const imgs = receiptHTML.getElementsByTagName('img');
    if (imgs && imgs.length) {
      await Promise.all(Array.from(imgs).map(img => new Promise(res => {
        if (img.complete) return res();
        img.onload = () => res();
        img.onerror = () => res();
      })));
    }
    const ppi = getPPI();
    const pixelsToMM = (px) => px * (25.4 / ppi);
    const contentHeightMM = pixelsToMM(receiptHTML.offsetHeight) * 1.1; // small buffer

    let printSettingsString = localStorage.getItem('PrinterSettings');
    let printSettings = JSON.parse(printSettingsString || '{}');
    // Map physical roll to printable width (approx): 80mm -> 72mm, 58mm -> 48mm
    const paperWidth = (printSettings?.receiptSize === '80') ? 72 : (printSettings?.receiptSize === '58') ? 48 : Number(printSettings?.receiptSize || 72);

    const opt = {
      margin: 0,
      html2canvas: { scale: 3, useCORS: true, backgroundColor: '#ffffff' },
      jsPDF: { unit: 'mm', format: [paperWidth, Math.max(contentHeightMM, 60)] }
    };

    try {
      const pdfBlob = await html2pdf().from(receiptHTML).set(opt).outputPdf('blob');
      const url = URL.createObjectURL(pdfBlob);
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = '0';
      document.body.appendChild(iframe);
      iframe.src = url;
      iframe.onload = () => {
        const cw = iframe.contentWindow;
        if (!cw) return;
        const cleanup = () => {
          try { URL.revokeObjectURL(url); } catch (_) {}
          try { document.body.removeChild(iframe); } catch (_) {}
          delete window.__receiptLogoDataUrl;
        };
        cw.onafterprint = () => { cleanup(); cw.onafterprint = null; };
        try {
          const mql = cw.matchMedia ? cw.matchMedia('print') : null;
          if (mql && mql.addListener) {
            mql.addListener((e) => { if (!e.matches) { cleanup(); try { mql.removeListener(); } catch (_) {} } });
          }
        } catch (_) {}
        const failSafe = setTimeout(() => { cleanup(); }, 30000);
        const originalAfterPrint = cw.onafterprint;
        cw.onafterprint = () => { clearTimeout(failSafe); if (originalAfterPrint) try { originalAfterPrint(); } catch (_) {} cleanup(); cw.onafterprint = null; };
        cw.focus();
        cw.print();
      };
    } finally {
      // Restore container
      if (printParent && prev) {
        printParent.style.position = prev.position;
        printParent.style.top = prev.top;
        printParent.style.left = prev.left;
        printParent.style.width = prev.width;
        printParent.style.maxHeight = prev.maxHeight;
        printParent.style.overflow = prev.overflow;
        printParent.style.opacity = prev.opacity;
        printParent.style.zIndex = prev.zIndex;
      }
    }
  }

  const receiptPrintClick = async () => {     // upated on san 2/6/25
    dispatch(setBillLoading(true));
    try {

      // Build a lookup of imageUrl from cartItems (keyed by productId)
      const imageUrlMap = {};
      (cartItems || []).forEach((item) => {
        if (item?.imageUrl && item?._id) imageUrlMap[item._id] = item.imageUrl;
      });
      // Enrich receiptData.orderInfo with imageUrl from cartItems
      const enrichedOrderInfo = (receiptData?.orderInfo || []).map((item) => ({
        ...item,
        imageUrl: item.imageUrl || imageUrlMap[item.productId] || imageUrlMap[item._id] || null,
      }));
      console.log('🖼️ enrichedOrderInfo imageUrls:', enrichedOrderInfo.map(i => ({ name: i.desccription || i.productName, imageUrl: i.imageUrl })));
      // Expose imageUrl map for PosReceiptTemplate to enrich its own orderInfo
      window.__receiptImageUrlMap = imageUrlMap;

      let printSettingsString = localStorage.getItem('PrinterSettings');
      let printSettings = JSON.parse(printSettingsString);

      // Try to fetch logo (prefer cached for offline), and set data URL for template display
      let companyLogo = null;
      let logoDataUrl = null;
      console.log('🖼️ Logo loading - companyProfileData?.logo:', companyProfileData?.logo);
      if (companyProfileData?.logo) {
        try {
          // Try cached image first
          const cachedBlob = await db.getCachedImage(companyProfileData.logo);
          console.log('🖼️ Logo loading - cachedBlob:', cachedBlob ? `Blob(${cachedBlob.size} bytes)` : 'null');
          if (cachedBlob) {
            companyLogo = cachedBlob;
            // Convert to data URL for template display
            logoDataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(cachedBlob);
            });
          } else {
            // Fallback to fetching online
            const fetched = await urlToBlob(companyProfileData.logo);
            console.log('🖼️ Logo loading - fetched blob:', fetched ? `Blob(${fetched.size} bytes)` : 'null');
            companyLogo = fetched;
            // Best effort: also make a data URL for inline display
            logoDataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(fetched);
            });
          }
          console.log('🖼️ Logo loading - logoDataUrl:', logoDataUrl ? `${logoDataUrl.substring(0, 50)}... (${logoDataUrl.length} chars)` : 'null');
        } catch (error) {
          console.warn('⚠️ Could not load logo (offline?) - printing without inline logo:', error?.message);
          companyLogo = null;
          logoDataUrl = null;
        }
      } else {
        console.warn('🖼️ Logo loading - No logo URL in companyProfileData');
      }

      // Expose logo data URL for PosReceiptTemplate to render inline (reliable for html2pdf)
      if (logoDataUrl) {
        window.__receiptLogoDataUrl = logoDataUrl;
      } else {
        delete window.__receiptLogoDataUrl;
      }

      const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(receiptData?.db)}&vendororcusid=${encodeURIComponent(receiptData?.cusId)}&type=POS&orderId=${encodeURIComponent(receiptData?._id)}`;

      let deliveryCharge = receiptData?.deliveryCharge || 0;
      let pkgCharge = receiptData?.pkgCharge || 0;
      let amtTotal = receiptData?.amtTotal;

      // Normalize customerName: backend returns object {name, mobileNo, ...}, offline stores plain string
      let customerName = receiptData?.customerName;
      if (typeof customerName === 'string') {
        customerName = [{ name: customerName }];
      } else if (Array.isArray(customerName)) {
        // Already an array — keep as-is
      } else if (customerName && typeof customerName === 'object' && customerName.name) {
        // Backend returns object {_id, name, mobileNo, ...} — wrap in array preserving all fields
        customerName = [customerName];
      } else {
        customerName = [{ name: 'cash customer' }];
      }

      // Prepare FormData for receipt print
      const formData = new FormData();
      formData.append('printerName', printSettings?.receiptPrinter);
      formData.append('printerWidth', printSettings?.receiptSize === "80" ? 48 : 32);
      formData.append('_id', receiptData?._id);
      formData.append('customerName', JSON.stringify(customerName));
      formData.append('cusId', receiptData?.cusId);
      formData.append('cashier', receiptData?.cashier || "");
      formData.append('waiterName', receiptData?.waiterName || "");
      formData.append('tables', JSON.stringify(receiptData?.tables));
      formData.append('name', receiptData?.name);
      formData.append('orderDate', receiptData?.orderDate);
      formData.append('ordType', receiptData?.ordType);
      formData.append('roundOff', (() => {
        // console.log("roundOff before toFixed:", receiptData?.roundOff);
        const val = receiptData?.roundOff || 0.00;
        console.log("roundOff ", val);
        return val;
      })());

      formData.append('totalExclusive', (() => {
        // console.log("totalExclusive before toFixed:", receiptData?.totalExclusive);
        const val = receiptData?.totalExclusive || 0.00;
        console.log("totalExclusive ", val);
        return val;
      })());


      formData.append('totalInclusive', (() => {
        // console.log("totalInclusive before toFixed:", receiptData?.totalInclusive);
        const val = receiptData?.totalInclusive || 0.00;
        console.log("totalInclusive ", val);
        return val;
      })());

      formData.append('amtTotal', (() => {
        // console.log("amtTotal before toFixed:", amtTotal);
        const val = amtTotal || 0.00;
        console.log("amtTotal :", val);
        return val;
      })());


      formData.append('discountAmt', (() => {
        // console.log("discountAmt before toFixed:", receiptData?.discountAmt);
        const val = receiptData?.discountAmt || 0.00;
        console.log("discountAmt ", val);
        return val;
      })());


      formData.append('taxableAmt', (() => {
        // console.log("taxableAmt before toFixed:", receiptData?.taxableAmt);
        const val = receiptData?.taxableAmt || 0.00;
        console.log("taxableAmt ", val);
        return val;
      })());


      formData.append('orderInfo', JSON.stringify(enrichedOrderInfo));
      formData.append('paymentInfo', JSON.stringify(receiptData?.paymentInfo));
      formData.append('kotInfo', JSON.stringify(receiptData?.kotInfo));
      formData.append('contactNumber', receiptData?.contactNumber || "");
      formData.append('template', posTemplateSelected?.posReceiptTemplate || "");
      formData.append('address', receiptData?.address || "");
      formData.append('nativeAddress', receiptData?.nativeAddress || "");
      formData.append('trnNumber', receiptData?.trnNumber || "");
      formData.append('email', receiptData?.email || "");
      formData.append('taxDetails', JSON.stringify(receiptData?.taxDetails));
      formData.append('logoFile', companyLogo || null);
      formData.append('mode', printSettings?.receiptImgMode || 1);
      formData.append('logoHeight', printSettings?.logoHeight || 20);
      formData.append('enableBarcode', printSettings?.enableBarcode || false);
      formData.append('enableQrCode', printSettings?.enableQrCode || false);
      formData.append('companyName', receiptData?.nameOfStore || "###");
      formData.append('invoiceUrl', domainAddress || window.location.host); formData.append('enableNativeName', printSettings?.enableNativeName || false);
      receiptData?.ordType === "DELIVERY" && formData.append('noOfCopies', branchConfigurationList?.printCount || 1);
      Number(deliveryCharge) > 0 && formData.append('deliveryCharge', Number(deliveryCharge)?.toFixed(decimalPosition) || 0.00);
      Number(pkgCharge) > 0 && formData.append('packagingCharge', Number(pkgCharge)?.toFixed(decimalPosition) || 0.00);
      formData.append('amoutInWords', numToWords(Number(amtTotal?.toFixed(decimalPosition))));
      formData.append('fontFamily', localStorage.getItem('posReceiptFont') || 'Arial');
      formData.append('enableNativeName', printSettings?.enableNativeName || false); if (receiptData?.ordType === "DELIVERY") {
        // formData.append('noOfCopies', branchConfigurationList?.printCount || 1);
      }
      if (Number(deliveryCharge) > 0) {
        formData.append('deliveryCharge', Number(deliveryCharge).toFixed(decimalPosition));
      }
      if (Number(pkgCharge) > 0) {
        formData.append('packagingCharge', Number(pkgCharge).toFixed(decimalPosition));
      }

      //  Step 1: Print Receipt First
      // Priority: Socket Print > QZ Tray (if enabled) > Thermal utility (if printer selected) > Browser print
      if (printSettings?.useSocketPrint && printSettings?.receiptPrinter) {
        // Socket Print mode - direct ESC/POS thermal print (clear text, zero margin)
        console.log('Using Socket Print (ESC/POS) for silent receipt print...');
        try {
          const { socketThermalPrint } = await import('../../Settings/Device Settings/socketPrintService');
          await socketThermalPrint({
            printerName: printSettings?.receiptPrinter,
            printerWidth: printSettings?.receiptSize === "80" ? 48 : 32,
            template: localStorage.getItem('posReceiptTemplate') || '1',
            logoBase64: logoDataUrl || null,
            logoWidth: printSettings?.logoWidth || 320,
            companyName: receiptData?.nameOfStore || "",
            invoiceUrl: domainAddress || window.location.host,
            address: receiptData?.address || "",
            name: receiptData?.name,
            customerName: customerName,
            tables: receiptData?.tables,
            orderInfo: enrichedOrderInfo,
            taxableAmt: receiptData?.taxableAmt || 0,
            taxDetails: receiptData?.taxDetails,
            amtTotal: amtTotal || 0,
            ordType: receiptData?.ordType,
            orderDate: receiptData?.orderDate,
            waiterName: receiptData?.waiterName || "",
            cashier: receiptData?.cashier || "",
            amoutInWords: numToWords(Number(amtTotal?.toFixed(decimalPosition))),
            paymentInfo: receiptData?.paymentInfo,
            deliveryCharge: Number(deliveryCharge) > 0 ? Number(deliveryCharge).toFixed(decimalPosition) : null,
            packagingCharge: Number(pkgCharge) > 0 ? Number(pkgCharge).toFixed(decimalPosition) : null,
            email: receiptData?.email || "",
            trnNumber: receiptData?.trnNumber || "",
            contactNumber: receiptData?.contactNumber || "",
            kotInfo: receiptData?.kotInfo,
            footerMsg: branchSettingsView?.termsAndCondition || receiptData?.termsAndConditions || "",
            mode: printSettings?.receiptImgMode || 1,
            logoHeight: printSettings?.logoHeight || 20,
            enableBarcode: printSettings?.enableBarcode || false,
            enableQrCode: printSettings?.enableQrCode || false,
            enableNativeName: printSettings?.enableNativeName || false,
            noOfCopies: receiptData?.ordType === "DELIVERY" ? (branchConfigurationList?.printCount || 1) : 1,
            isQuickBill: receiptData?.isQuickBill || false,
            roundOff: receiptData?.roundOff || 0,
          });
        } catch (socketErr) {
          console.error('Socket print failed, falling back to thermal utility:', socketErr);
          await printRequestAPICall(formData, posReceiptPrint);
        }
      } else if (printSettings?.useBrowserPrint && printSettings?.receiptPrinter) {
        // QZ Tray mode enabled with printer selected - use QZ Tray for silent print
        console.log('Using QZ Tray for silent receipt print...');
        const qzAvailable = await isQzTrayAvailable();
        if (qzAvailable) {
          // Generate PDF and print via QZ Tray
          const receiptHTML = invoicePrint.current;
          if (receiptHTML) {
            const ppi = getPPI();
            const pixelsToMM = (px) => px * (25.4 / ppi);
            const contentHeightMM = pixelsToMM(receiptHTML.offsetHeight) * 1.1;
            const paperWidth = (printSettings?.receiptSize === '80') ? 72 : 48;
            const opt = {
              margin: 0,
              html2canvas: { scale: 3, useCORS: true, backgroundColor: '#ffffff' },
              jsPDF: { unit: 'mm', format: [paperWidth, Math.max(contentHeightMM, 60)] }
            };
            const pdfBlob = await html2pdf().from(receiptHTML).set(opt).outputPdf('blob');
            await qzTrayPdfPrintAPICall(printSettings.receiptPrinter, pdfBlob, { width: paperWidth }, posReceiptPrint);
          }
        } else {
          // QZ Tray not available, fallback to browser print
          console.log('QZ Tray not available, falling back to browser print...');
          await posReceiptPrint();
        }
      } else if (printSettings?.receiptPrinter) {
        // Thermal utility mode - printer selected, use localhost:5000
        console.log('Using thermal print utility for receipt...');
        await printRequestAPICall(formData, posReceiptPrint);
      } else if (printSettings?.useBrowserPrint) {
        // QZ Tray enabled but no printer selected - use browser default
        console.log('QZ Tray enabled but no printer selected, using browser print...');
        await posReceiptPrint();
      } else {
        // No printer configured and no QZ Tray - show print dialog
        console.log('No printer configured, using browser print dialog...');
        await posReceiptPrint();
      }

      // ========== ADDITIONAL RECEIPT PRINTERS - Print actual receipt ==========
      const additionalReceiptPrinters = printSettings?.additionalReceiptPrinters || [];
      for (const additionalReceipt of additionalReceiptPrinters) {
        // Check if this additional receipt printer has auto enabled and a printer selected
        if (additionalReceipt?.printer && additionalReceipt?.auto) {
          console.log(`🖨️ Additional Receipt Printer [${additionalReceipt.areaName}] - printing receipt...`);
          
          // Create FormData for this additional printer with its own settings
          const additionalFormData = new FormData();
          additionalFormData.append('printerName', additionalReceipt.printer);
          additionalFormData.append('printerWidth', additionalReceipt?.size === "80" ? 48 : 32);
          additionalFormData.append('_id', receiptData?._id);
          additionalFormData.append('customerName', JSON.stringify(customerName));
          additionalFormData.append('cusId', receiptData?.cusId);
          additionalFormData.append('cashier', receiptData?.cashier || "");
          additionalFormData.append('waiterName', receiptData?.waiterName || "");
          additionalFormData.append('tables', JSON.stringify(receiptData?.tables));
          additionalFormData.append('name', receiptData?.name);
          additionalFormData.append('orderDate', receiptData?.orderDate);
          additionalFormData.append('ordType', receiptData?.ordType);
          additionalFormData.append('roundOff', receiptData?.roundOff || 0.00);
          additionalFormData.append('totalExclusive', receiptData?.totalExclusive || 0.00);
          additionalFormData.append('totalInclusive', receiptData?.totalInclusive || 0.00);
          additionalFormData.append('amtTotal', amtTotal || 0.00);
          additionalFormData.append('discountAmt', receiptData?.discountAmt || 0.00);
          additionalFormData.append('taxableAmt', receiptData?.taxableAmt || 0.00);
          additionalFormData.append('orderInfo', JSON.stringify(enrichedOrderInfo));
          additionalFormData.append('paymentInfo', JSON.stringify(receiptData?.paymentInfo));
          additionalFormData.append('kotInfo', JSON.stringify(receiptData?.kotInfo));
          additionalFormData.append('contactNumber', receiptData?.contactNumber || "");
          additionalFormData.append('template', posTemplateSelected?.posReceiptTemplate || "");
          additionalFormData.append('address', receiptData?.address || "");
          additionalFormData.append('nativeAddress', receiptData?.nativeAddress || "");
          additionalFormData.append('trnNumber', receiptData?.trnNumber || "");
          additionalFormData.append('email', receiptData?.email || "");
          additionalFormData.append('taxDetails', JSON.stringify(receiptData?.taxDetails));
          additionalFormData.append('logoFile', companyLogo || null);
          additionalFormData.append('mode', additionalReceipt?.imgMode || 1);
          additionalFormData.append('logoHeight', additionalReceipt?.logoHeight || 20);
          additionalFormData.append('enableBarcode', additionalReceipt?.enableBarcode || false);
          additionalFormData.append('enableQrCode', additionalReceipt?.enableQrCode || false);
          additionalFormData.append('companyName', receiptData?.nameOfStore || "###");
          additionalFormData.append('invoiceUrl', domainAddress || window.location.host);
          additionalFormData.append('enableNativeName', additionalReceipt?.enableNativeName || false);
          additionalFormData.append('fontFamily', localStorage.getItem('posReceiptFont') || 'Arial');
          if (Number(deliveryCharge) > 0) {
            additionalFormData.append('deliveryCharge', Number(deliveryCharge).toFixed(decimalPosition));
          }
          if (Number(pkgCharge) > 0) {
            additionalFormData.append('packagingCharge', Number(pkgCharge).toFixed(decimalPosition));
          }
          additionalFormData.append('amoutInWords', numToWords(Number(amtTotal?.toFixed(decimalPosition))));

          // Print receipt to additional printer
          if (printSettings?.useBrowserPrint && additionalReceipt.printer) {
            const qzAvailable = await isQzTrayAvailable();
            if (qzAvailable) {
              const receiptHTML = invoicePrint.current;
              if (receiptHTML) {
                const ppi = getPPI();
                const pixelsToMM = (px) => px * (25.4 / ppi);
                const contentHeightMM = pixelsToMM(receiptHTML.offsetHeight) * 1.1;
                const paperWidth = (additionalReceipt?.size === '80') ? 72 : 48;
                const opt = {
                  margin: 0,
                  html2canvas: { scale: 3, useCORS: true, backgroundColor: '#ffffff' },
                  jsPDF: { unit: 'mm', format: [paperWidth, Math.max(contentHeightMM, 60)] }
                };
                const pdfBlob = await html2pdf().from(receiptHTML).set(opt).outputPdf('blob');
                await qzTrayPdfPrintAPICall(additionalReceipt.printer, pdfBlob, { width: paperWidth }, () => {});
              }
            } else {
              // QZ not available, use thermal utility
              await printRequestAPICall(additionalFormData, () => {});
            }
          } else if (additionalReceipt.printer) {
            // Thermal utility mode
            await printRequestAPICall(additionalFormData, () => {});
          }
        }
      }

      //  Step 2: Print KOTs after receipt
      const shouldPrintKot = printSettings?.enableKotPrint && printSettings?.receiptAuto;// upated on san 11/6/25
      console.log('🎫 KOT Print Check:', {
        enableKotPrint: printSettings?.enableKotPrint,
        receiptAuto: printSettings?.receiptAuto,
        shouldPrintKot,
        kotDataLength: receiptData?.kotData?.length || 0,
        kotData: receiptData?.kotData
      });

      if (shouldPrintKot && receiptData?.kotData?.length > 0) {
        // Receipt "Kot print" enabled - print KOT on RECEIPT printer
        const kotPrintPromises = receiptData.kotData.map(async (kot) => {
          // Use RECEIPT printer settings for this KOT (not KOT printer)
          const kotPayloadForReceipt = {
            printerWidth: printSettings?.receiptSize === "80" ? 48 : 32,
            printerName: printSettings?.receiptPrinter, // Use receipt printer
            enableNativeName: printSettings?.enableReceiptNativeName || false,
            transNo: kot.name || receiptData?.name,
            ordName: kot.ordName || receiptData?.ordName,
            orderDate: kot.orderDate || receiptData?.orderDate,
            ordType: kot.ordType || receiptData?.ordType,
            waiterName: kot.waiterName || receiptData?.waiterName || "-NIL-",
            orderInfo: kot.orderInfo || receiptData?.orderInfo,
            tables: kot.tables || receiptData?.tables,
            floorName: kot.floorName || receiptData?.floorName,
            kotPrintNotes: printSettings?.kotPrintNotes || false,
          };

          // Print KOT on RECEIPT printer
          if (printSettings?.useBrowserPrint && printSettings?.receiptPrinter) {
            console.log('Trying QZ Tray for KOT on RECEIPT printer...', kotPayloadForReceipt);
            const qzAvailable = await isQzTrayAvailable();
            if (qzAvailable) {
              const receiptWidth = printSettings?.receiptSize === '80' ? 72 : 48;
              const success = await qzTrayKotPrintAPICall(printSettings.receiptPrinter, kotPayloadForReceipt, { width: receiptWidth });
              if (!success) {
                console.log('QZ Tray KOT on receipt printer failed, falling back to browser print...');
                handlePrintKot();
              }
            } else {
              console.log('QZ Tray not available, trying thermal utility for KOT on receipt printer...');
              await smartKotPrint(kotPayloadForReceipt, handlePrintKot);
            }
          } else if (printSettings?.receiptPrinter) {
            console.log('Using thermal utility for KOT on RECEIPT printer...', kotPayloadForReceipt);
            await smartKotPrint(kotPayloadForReceipt, handlePrintKot);
          } else {
            handlePrintKot();
          }

        });

        await Promise.all(kotPrintPromises);
      }


      if (printSettings?.kotAuto && // added on san 4/6/25
        printSettings?.enableKotPrintAfterPayment &&
        receiptData?.kotData?.length > 0
        //  &&
        // receiptData?.ordType === "DINEIN" // upated on san 11/6/25

      ) {
        console.log('Triggering KOT print after payment (kotAuto + enableKotPrintAfterPayment enabled)...');

        for (const kot of receiptData.kotData) {
          // Filter orderInfo for main KOT printer
          const kotFilteredOrderInfo = expandToRawMaterials(
            filterKotOrderInfo(kot.orderInfo || receiptData?.orderInfo, printSettings?.kotFilterProductIds),
            printSettings?.kotRawMaterial
          );
          if (kotFilteredOrderInfo.length === 0) continue; // Skip if no matching items

          const kotPayload = {
            printerWidth: printSettings?.kotSize === "80" ? 48 : 32,
            printerName: printSettings?.kotPrinter,
            enableNativeName: printSettings?.enableKotNativeName || false,
            transNo: kot.name || receiptData?.name,
            ordName: kot.ordName || receiptData?.ordName,
            orderDate: kot.orderDate || receiptData?.orderDate,
            ordType: kot.ordType || receiptData?.ordType,
            waiterName: kot.waiterName || receiptData?.waiterName || "-NIL-",
            orderInfo: kotFilteredOrderInfo,
            tables: kot.tables || receiptData?.tables,
            floorName: kot.floorName || receiptData?.floorName,
            kotPrintNotes: printSettings?.kotPrintNotes || false,
          };

          // Priority: QZ Tray (if enabled) > Thermal utility > Browser print
          if (printSettings?.useBrowserPrint && printSettings?.kotPrinter) {
            // Try QZ Tray first
            console.log('Trying QZ Tray for KOT print after payment...', kotPayload);
            const qzAvailable = await isQzTrayAvailable();
            if (qzAvailable) {
              const kotWidth = printSettings?.kotSize === '80' ? 72 : 48;
              const success = await qzTrayKotPrintAPICall(printSettings.kotPrinter, kotPayload, { width: kotWidth });
              if (!success) {
                // QZ Tray failed, fall back to browser print
                console.log('QZ Tray KOT failed, falling back to browser print...');
                handlePrintKot();
              }
            } else {
              // QZ Tray not available, try thermal utility then browser print
              console.log('QZ Tray not available, trying thermal utility for KOT...');
              smartKotPrint(kotPayload, handlePrintKot);
            }
          } else if (printSettings?.kotPrinter) {
            // Thermal utility mode - try thermal, fallback to browser print
            console.log('Using thermal utility for KOT print after payment...', kotPayload);
            smartKotPrint(kotPayload, handlePrintKot);
          } else {
            // No printer configured, use browser print
            handlePrintKot();
          }
        }
      }

      // ========== ADDITIONAL KOT PRINTERS - Print after payment ==========
      const additionalKotPrinters = printSettings?.additionalKotPrinters || [];
      for (const additionalKot of additionalKotPrinters) {
        // Check if this additional KOT printer has "Kot print after payment" enabled
        if (additionalKot?.enableKotPrintAfterPayment && additionalKot?.printer && additionalKot?.auto && receiptData?.kotData?.length > 0) {
          console.log(`🖨️ Additional KOT Printer [${additionalKot.areaName}] - printing after payment...`);
          
          for (const kot of receiptData.kotData) {
            // Filter orderInfo for this additional KOT printer
            const additionalFilteredOrderInfo = expandToRawMaterials(
              filterKotOrderInfo(kot.orderInfo || receiptData?.orderInfo, additionalKot?.kotFilterProductIds),
              additionalKot?.kotRawMaterial
            );
            if (additionalFilteredOrderInfo.length === 0) continue; // Skip if no matching items

            const additionalKotPayload = {
              printerWidth: additionalKot?.size === "80" ? 48 : 32,
              printerName: additionalKot.printer,
              enableNativeName: additionalKot?.enableNativeName || false,
              transNo: kot.name || receiptData?.name,
              ordName: kot.ordName || receiptData?.ordName,
              orderDate: kot.orderDate || receiptData?.orderDate,
              ordType: kot.ordType || receiptData?.ordType,
              waiterName: kot.waiterName || receiptData?.waiterName || "-NIL-",
              orderInfo: additionalFilteredOrderInfo,
              tables: kot.tables || receiptData?.tables,
              floorName: kot.floorName || receiptData?.floorName,
              areaName: additionalKot.areaName, // Include area name for identification
              kotPrintNotes: additionalKot?.kotPrintNotes || false,
            };

            // Use thermal utility for additional KOT printers
            if (printSettings?.useBrowserPrint && additionalKot.printer) {
              const qzAvailable = await isQzTrayAvailable();
              if (qzAvailable) {
                const kotWidth = additionalKot?.size === '80' ? 72 : 48;
                await qzTrayKotPrintAPICall(additionalKot.printer, additionalKotPayload, { width: kotWidth });
              } else {
                smartKotPrint(additionalKotPayload, handlePrintKot);
              }
            } else if (additionalKot.printer) {
              smartKotPrint(additionalKotPayload, handlePrintKot);
            }
          }
        }
      }

      // ========== ADDITIONAL RECEIPT PRINTERS - Print KOT on receipt printer ==========
      // Reuse additionalReceiptPrinters from above
      for (const additionalReceipt of additionalReceiptPrinters) {
        // Check if this additional receipt printer has "Kot print" enabled
        if (additionalReceipt?.enableKotPrint && additionalReceipt?.printer && additionalReceipt?.auto && receiptData?.kotData?.length > 0) {
          console.log(`🖨️ Additional Receipt Printer [${additionalReceipt.areaName}] - printing KOT...`);
          
          for (const kot of receiptData.kotData) {
            const additionalKotPayload = {
              printerWidth: additionalReceipt?.size === "80" ? 48 : 32,
              printerName: additionalReceipt.printer,
              enableNativeName: additionalReceipt?.enableNativeName || false,
              transNo: kot.name || receiptData?.name,
              ordName: kot.ordName || receiptData?.ordName,
              orderDate: kot.orderDate || receiptData?.orderDate,
              ordType: kot.ordType || receiptData?.ordType,
              waiterName: kot.waiterName || receiptData?.waiterName || "-NIL-",
              orderInfo: kot.orderInfo || receiptData?.orderInfo,
              tables: kot.tables || receiptData?.tables,
              floorName: kot.floorName || receiptData?.floorName,
              areaName: additionalReceipt.areaName, // Include area name for identification
              kotPrintNotes: printSettings?.kotPrintNotes || false,
            };

            // Use thermal utility for additional receipt printers
            if (printSettings?.useBrowserPrint && additionalReceipt.printer) {
              const qzAvailable = await isQzTrayAvailable();
              if (qzAvailable) {
                const receiptWidth = additionalReceipt?.size === '80' ? 72 : 48;
                await qzTrayKotPrintAPICall(additionalReceipt.printer, additionalKotPayload, { width: receiptWidth });
              } else {
                smartKotPrint(additionalKotPayload, handlePrintKot);
              }
            } else if (additionalReceipt.printer) {
              smartKotPrint(additionalKotPayload, handlePrintKot);
            }
          }
        }
      }

    } catch (error) {
      console.error("Error generating print:", error);
    } finally {
      dispatch(setBillLoading(false));
    }
  };

  // const receiptPrintClick = async () => {
  //     dispatch(setBillLoading(true));
  //     try {

  //       let printSettingsString = localStorage.getItem('PrinterSettings')
  //       let printSettings = JSON.parse(printSettingsString)

  //       const companyLogo = companyProfileData?.logo && await urlToBlob(companyProfileData?.logo)
  //       const domainAddress = `${window.location.protocol}//${window.location.host}/posReaderPreview?path=admin/viewqrcodedata&db=${encodeURIComponent(receiptData?.db)}&vendororcusid=${encodeURIComponent(receiptData?.cusId)}&type=${encodeURIComponent("POS")}&orderId=${encodeURIComponent(receiptData?._id)}`;

  //       let deliveryCharge = receiptData?.deliveryCharge || 0;
  //       let pkgCharge = receiptData?.pkgCharge || 0;
  //       let amtTotal = receiptData?.amtTotal;

  //       console.log(domainAddress)

  //       const formData = new FormData();
  //       formData.append('printerName', printSettings?.receiptPrinter);
  //       formData.append('printerWidth', printSettings?.receiptSize === "80" ? 48 : 32);
  //       formData.append('_id', receiptData?._id);
  //       formData.append('customerName', JSON.stringify(receiptData?.customerName));
  //       formData.append('cusId', receiptData?.cusId);
  //       formData.append('cashier', receiptData?.cashier || "");
  //       formData.append('waiterName', receiptData?.waiterName || "");
  //       formData.append('tables', JSON.stringify(receiptData?.tables));
  //       formData.append('name', receiptData?.name);
  //       formData.append('orderDate', receiptData?.orderDate);
  //       formData.append('ordType', receiptData?.ordType);
  //       formData.append('totalExclusive', receiptData?.totalExclusive?.toFixed(decimalPosition));
  //       formData.append('totalInclusive', receiptData?.totalInclusive?.toFixed(decimalPosition));
  //       formData.append('amtTotal', amtTotal?.toFixed(decimalPosition));
  //       formData.append('discountAmt', receiptData?.discountAmt?.toFixed(decimalPosition));
  //       formData.append('taxableAmt', receiptData?.taxableAmt?.toFixed(decimalPosition));
  //       formData.append('orderInfo', JSON.stringify(receiptData?.orderInfo));
  //       formData.append('paymentInfo', JSON.stringify(receiptData?.paymentInfo));
  //       formData.append('kotInfo', JSON.stringify(receiptData?.kotInfo));
  //       formData.append('contactNumber', receiptData?.contactNumber || "");
  //       formData.append('template', posTemplateSelected?.posReceiptTemplate || "");
  //       formData.append('address', receiptData?.address || "");
  //       formData.append('nativeAddress', receiptData?.nativeAddress || "");
  //       formData.append('trnNumber', receiptData?.trnNumber || "");
  //       formData.append('email', receiptData?.email || "");
  //       formData.append('taxDetails', JSON.stringify(receiptData?.taxDetails));
  //       formData.append('logoFile', companyLogo || null);
  //       formData.append('mode', printSettings?.receiptImgMode || 1);
  //       formData.append('logoHeight', printSettings?.logoHeight || 20);
  //       formData.append('enableBarcode', printSettings?.enableBarcode || false);
  //       formData.append('enableQrCode', printSettings?.enableQrCode || false);
  //       formData.append('companyName', receiptData?.nameOfStore || "###");
  //       formData.append('invoiceUrl', domainAddress || window.location.host);
  //       receiptData?.ordType === "DELIVERY" && formData.append('noOfCopies', branchConfigurationList?.printCount || 1);
  //       Number(deliveryCharge) > 0 && formData.append('deliveryCharge', Number(deliveryCharge)?.toFixed(decimalPosition) || 0.00);
  //       Number(pkgCharge) > 0 && formData.append('packagingCharge', Number(pkgCharge)?.toFixed(decimalPosition) || 0.00);
  //       formData.append('amoutInWords', numToWords(Number(amtTotal?.toFixed(decimalPosition))));
  //       formData.append('enableNativeName', printSettings?.enableNativeName || false);


  //       if (printSettings?.receiptPrinter) {
  //         printRequestAPICall(formData, posReceiptPrint);
  //       } else {
  //         posReceiptPrint();
  //       }


  //         // If KOT auto-print is enabled and this is a DINEIN order, print KOT
  //     if (printSettings?.enableKotPrint && printSettings?.kotAuto && receiptData?.ordType === "DINEIN") {//added on 30-05-25 by san

  //       const kotPayload = {
  //         printerWidth: printSettings?.kotSize === "80" ? 48 : 32,
  //         printerName: printSettings?.kotPrinter,
  //         enableNativeName: printSettings?.enableKotNativeName || false,
  //         transNo: receiptData?.trnNumber,
  //         ordName: receiptData?.name,
  //         orderDate: receiptData?.orderDate,
  //         ordType: receiptData?.ordType,
  //         waiterName: receiptData?.waiterName || "-NIL-",
  //         orderInfo: receiptData?.orderInfo,
  //         tables: receiptData?.tables,
  //         floorName: receiptData?.floorName
  //       };

  //       if (printSettings?.kotPrinter) {
  //         await smartKotPrint(kotPayload, handlePrintKot);
  //       } else {
  //         handlePrintKot();
  //       }

  //     }
  //     } catch (error) {
  //       console.error("Error generating PDF:", error);
  //     } finally {
  //       dispatch(setBillLoading(false));
  //     }
  //   };
  // initial API Calls

  useEffect(() => {
    listAllFloorAPI();
    viewPosSettingsAPICall();
    // Load categories - will be filtered by assignedCategoryIds if device has restrictions
    const categoryParams = { isPos: true, branchId: userBranchId };
    if (assignedCategoryIds && assignedCategoryIds.length > 0) {
      categoryParams.categoryIds = assignedCategoryIds;
    }
    categoryListAPICall(categoryParams);
    getBranchConfiguration({ branchId: userBranchId });
    // Complete branch settings will be fetched in a separate useEffect after basic config loads
    getAllSubCatForBilling({ isPos: true, branchId: userBranchId });
    listAggregatorsAPI({ branchId: userRole === "user" ? userInfo?.branchPk : undefined });
    setTimeout(() => {
      // Load template from localStorage first (most reliable), then fetch from API as backup
      const localTemplate = localStorage.getItem('posReceiptTemplate');
      if (localTemplate) {
        console.log('🧾 BillingNew: Using localStorage template:', localTemplate);
        dispatch(setPosReceiptSlice({ posReceiptTemplate: Number(localTemplate) }));
      } else {
        getTemplateInfoAPI();
      }
      paymentTypesForBilling({ branchId: userBranchId });
      listAggregatorsAPI({ branchId: userBranchId });
      listHeldOrders({ branchId: userBranchId, type: 1 });
      listReservationList({ branchId: userBranchId });
      completedSelfOrderLists({ branchId: userBranchId })
      viewCardManualAPICall();
      defaultCustomer === null && defaultCustomerForPOSAPI({})
    }, 2000);
    dispatch(setPOSBranchId(userBranchId));
    dispatch(setOrderIdInPOS(null))
    dispatch(setCartProductType(1))
  }, []);

  // Fetch complete branch settings when basic config loads
  useEffect(() => {
    if (branchConfigurationList?._id) {
      console.log('📡 Basic branch config loaded, fetching complete settings with _id:', branchConfigurationList._id);
      branchSettingsSingleView({ _id: branchConfigurationList._id });
    }
  }, [branchConfigurationList?._id]);

  // Refresh order list when offline sync completes
  useEffect(() => {
    const handleSyncComplete = () => {
      console.log('🔄 Sync complete - refreshing ongoing orders');
      listHeldOrders({ branchId: userBranchId, type: 1 });
      // Re-fetch default customer if it was missed while offline
      if (!defaultCustomer) {
        console.log('🔄 Re-fetching default customer after coming online');
        defaultCustomerForPOSAPI({});
      }
    };

    window.addEventListener('offlineSyncComplete', handleSyncComplete);
    return () => window.removeEventListener('offlineSyncComplete', handleSyncComplete);
  }, [userBranchId, defaultCustomer]);

  // Reload categories when device assignment changes
  useEffect(() => {
    if (assignedCategoryIds && assignedCategoryIds.length > 0) {
      console.log('🔄 Device has category restrictions, reloading categories:', assignedCategoryIds);
      categoryListAPICall({ 
        isPos: true, 
        branchId: userBranchId,
        categoryIds: assignedCategoryIds 
      });
    }
  }, [assignedCategoryIds?.length]);

  // rendered whenever cart is modified
  useEffect(() => {
    calculateAndSetCalculatedValues();
  }, [isCartModified]);

  // default set the screen to floorPlan
  useEffect(() => {
    floors?.length !== 0 && dispatch(setBtnSelected("floorPlan"));
  }, [floors]);

  // api call to get the single order info
  useEffect(() => {
    orderIdForPos !== null
      ? singlePOSOrderInfoAPICall({ id: orderIdForPos })
      : dispatch(setSingleOrderInfo(null));
  }, [orderIdForPos]);

  // selected order info apllying in the screen
  useEffect(() => {
    if (singleOrderInfo !== null) {
      const orderInfo = singleOrderInfo?.orderInfo?.map((item) => ({
        customerNote: item?.customerNote || null,
        productName: item?.desccription || "",
        includedPrice:
          item?.includedPrice === true
            ? true
            : item?.includedPrice === false
              ? false
              : null,
        kotOrderId: item?.kotOrderId,
        kotStatus: item?.kotStatus,
        lineTotal: item?.lineTotal || 0,
        _id: item?.productId,
        quantity: item?.qty,
        subTotalWoTax: item?.subTotalWoTax,
        taxes: item.taxes,
        salesPrice: item?.unitPrice,
        uom: item?.uom,
        existingId: item?._id,
        objType: "eq",
        lastQty: item?.qty,
        imageUrl: item?.imageUrl,
        itemType: item?.itemType,
        mainCatgeoryId: item?.mainCatgeoryId || null,
        // Use the loaded price as the minimum allowed when protection is enabled
        minSalesPrice: Number(item?.unitPrice ?? 0),
      }));
      setCartItems(orderInfo);
      setDuplicateCartArray(orderInfo);
      setIsCartModified(!isCartModified);
      
      // Restore delivery KM and charge from loaded order to prevent dialog from reopening
      console.log('🔍 Checking order for delivery data:', {
        selfDeliveryKm: singleOrderInfo?.selfDeliveryKm,
        deliveryCharge: singleOrderInfo?.deliveryCharge,
        ordType: singleOrderInfo?.ordType
      });
      
      // For delivery orders with self aggregator, restore the delivery data
      if (singleOrderInfo?.ordType === 'DELIVERY' && singleOrderInfo?.deliveryCharge > 0) {
        // If backend returns selfDeliveryKm, use it directly
        if (singleOrderInfo?.selfDeliveryKm) {
          console.log('🔄 Restoring delivery data from order (backend provided KM):', {
            deliveryCharge: singleOrderInfo.deliveryCharge,
            selfDeliveryKm: singleOrderInfo.selfDeliveryKm
          });
          
          dispatch(setSelfDeliveryCharge(singleOrderInfo.deliveryCharge));
          dispatch(setSelfDeliveryKm(singleOrderInfo.selfDeliveryKm));
        } else {
          // Backend doesn't return selfDeliveryKm
          // For per_km mode, we can calculate it. For km_range mode, we can't accurately reverse-calculate
          // So just restore the charge and set a flag KM to prevent dialog reopening
          console.log('🔄 Restoring delivery charge only (KM not available from backend):', {
            deliveryCharge: singleOrderInfo.deliveryCharge
          });
          
          dispatch(setSelfDeliveryCharge(singleOrderInfo.deliveryCharge));
          // Set a non-zero KM to prevent dialog from reopening, but don't try to calculate exact value
          // The payment screen will use the deliveryCharge from the order directly
          dispatch(setSelfDeliveryKm(1)); // Dummy value to indicate KM was entered
        }
      }
    } else {
      setCartItems([]);
      setDuplicateCartArray([]);
    }
  }, [singleOrderInfo]);

  // Ref to store socket instance for customer display
  const customerDisplaySocketRef = React.useRef(null);
  const socketReadyRef = React.useRef(false);

  // effects to focusing input fields in cart
  useEffect(() => {
    qtyInputRefs.current = cartItems?.map(() => React.createRef());
    salesPriceRefs.current = cartItems?.map(() => React.createRef());
  }, [cartItems]);

  // Socket connection for customer display (run once)
  useEffect(() => {
    // Initialize real Socket.IO connection
    const socket = io(axios.defaults.baseURL, {
      path: "/socket.io/",
      reconnection: true,
      transports: ["websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
    });
    customerDisplaySocketRef.current = socket;

    socket.on("connect", () => {
      console.log('🔌 Billing Socket.IO connected');
      hybridSocket.setBackendStatus(true);
      hybridSocket.setRealSocket(socket);
      
      if (employeeId && userBranchId) {
        console.log('🔌 Billing: Setting username with employeeId:', employeeId, 'branchId:', userBranchId);
        socket.emit("setUsername", employeeId, userBranchId);
      }
    });

    socket.on("usernameSet", (res) => {
      console.log('🔌 Billing: Username set confirmed:', res);
      socketReadyRef.current = true;
    });

    socket.on("disconnect", () => {
      console.log('🔌 Billing Socket.IO disconnected');
      hybridSocket.setBackendStatus(false);
      socketReadyRef.current = false;
    });

    socket.on("connect_error", () => {
      console.log('❌ Billing Socket.IO connection error - switching to offline mode');
      hybridSocket.setBackendStatus(false);
      socketReadyRef.current = false;
    });

    // Register listener for incoming cart updates (from other devices/tabs)
    const handleCartUpdate = (data) => {
      console.log('📥 Billing: Received cart update:', data);
      // Handle incoming cart data if needed
    };
    hybridSocket.on("posBillingCart", handleCartUpdate);

    // Listen for UPI payment success from webhook
    socket.on("upiPaymentSuccess", (data) => {
      console.log('✅ UPI Payment Success received via socket:', data);
      setUpiPaymentSuccessData(data);
    });

    // Listen for UPI payment failure from webhook
    socket.on("upiPaymentFailed", (data) => {
      console.log('❌ UPI Payment Failed received via socket:', data);
      setUpiPaymentFailedData(data);
    });

    return () => {
      // Clean up
      hybridSocket.off("posBillingCart", handleCartUpdate);
      socket.off("connect");
      socket.off("usernameSet");
      socket.off("disconnect");
      socket.off("connect_error");
      socket.off("upiPaymentSuccess");
      socket.off("upiPaymentFailed");
      socket.disconnect();
      customerDisplaySocketRef.current = null;
      socketReadyRef.current = false;
    };
  }, [employeeId, userBranchId]); // Only reconnect if user/branch changes

  // Emit cart updates to customer display (run on cart changes)
  useEffect(() => {
    const socket = customerDisplaySocketRef.current;
    if (!socket || !socket.connected) {
      return;
    }

    // Calculate totals inline to ensure we have the latest values
    // This avoids timing issues with calculateAndSetCalculatedValues
    let subTotal = 0;
    let taxTotal = 0;
    let grandTotal = 0;
    
    const orderInfo = cartItems?.map((item) => {
      const qty = Number(item?.quantity || 0);
      const price = Number(item?.salesPrice || 0);
      const baseAmount = qty * price;
      const taxArray = item?.taxes || [];
      
      // Calculate tax if not already calculated
      let itemExclTax = item?.exclusiveTax;
      let itemInclTax = item?.inclusiveTax;
      let itemSubTotal = item?.subTotalWoTax;
      let itemLineTotal = item?.lineTotal;
      
      // If tax values not calculated yet, calculate them inline
      if (itemExclTax === undefined || itemInclTax === undefined) {
        if (item?.includedPrice === "true" || item?.includedPrice === true) {
          // Inclusive tax
          const totalInclArr = taxArray.map((tax) => {
            const rate = tax?.amount || 0;
            return (baseAmount * rate) / (100 + rate);
          });
          itemInclTax = totalInclArr.reduce((sum, t) => sum + t, 0);
          itemExclTax = 0;
          itemSubTotal = baseAmount;
          itemLineTotal = baseAmount;
        } else if (item?.includedPrice === "false" || item?.includedPrice === false) {
          // Exclusive tax
          itemExclTax = taxArray.reduce((sum, tax) => {
            const rate = tax?.amount || 0;
            return sum + (baseAmount * rate) / 100;
          }, 0);
          itemInclTax = 0;
          itemSubTotal = baseAmount;
          itemLineTotal = baseAmount + itemExclTax;
        } else {
          // No tax
          itemExclTax = 0;
          itemInclTax = 0;
          itemSubTotal = baseAmount;
          itemLineTotal = baseAmount;
        }
      }
      
      subTotal += (itemSubTotal || baseAmount);
      taxTotal += ((itemExclTax || 0) + (itemInclTax || 0));
      grandTotal += (itemLineTotal || baseAmount);
      
      return {
        _id: item?._id,
        desccription: item?.productName,
        qty: qty,
        unitPrice: price,
        subTotalWoTax: itemSubTotal || baseAmount,
        lineTotal: itemLineTotal || baseAmount,
        imageUrl: item?.imageUrl,
      };
    }) || [];
    
    console.log('📤 Billing: Emitting cart update to customer display:', { 
      branchId: userBranchId, 
      itemCount: orderInfo?.length, 
      subTotal,
      taxTotal,
      grandTotal,
      socketReady: socketReadyRef.current 
    });
    
    socket.emit(
      "posBillingCartEmit",
      {
        branchId: userBranchId,
        userId: employeeId,
      },
      { 
        orderInfo, 
        subTotal, 
        taxTotal,
        grandTotal,
        customerDisplayQRInfo 
      }
    );
  }, [cartItems, customerDisplayQRInfo, userBranchId, employeeId]);

  // Separate effect for QR info changes to ensure immediate emit
  useEffect(() => {
    const socket = customerDisplaySocketRef.current;
    if (!socket || !socket.connected) {
      return;
    }
    
    // Only emit if QR info has meaningful data (open or has status change)
    if (customerDisplayQRInfo?.open || customerDisplayQRInfo?.status === 'success' || customerDisplayQRInfo?.status === 'declined') {
      console.log('📤 Billing: Emitting QR info update:', customerDisplayQRInfo);
      socket.emit(
        "posBillingCartEmit",
        {
          branchId: userBranchId,
          userId: employeeId,
        },
        { 
          orderInfo: [], 
          subTotal: 0, 
          taxTotal: 0,
          grandTotal: 0,
          customerDisplayQRInfo 
        }
      );
    }
  }, [customerDisplayQRInfo, userBranchId, employeeId]);

  // auto printer
  // useEffect(() => {
  //   let printSettingsString = localStorage.getItem('PrinterSettings')
  //   let printSettings = JSON.parse(printSettingsString)
  //   if (dialogOpen === "invoicePrint" || dialogOpen === "deliveryPrint") {
  //     setTimeout(() => {
  //       printSettings?.receiptAuto && receiptPrintClick()
  //     }, 0);
  //   } else if (dialogOpen === "autoPrintKot") {
  //     setTimeout(() => {
  //       kotPrintClick(kotSingleData)
  //     }, 0);
  //   }
  // }, [dialogOpen])

  // Load billing theme from POS settings
  useEffect(() => {
    console.log('posSettingsList:', posSettingsList);
    console.log('posSettingsList.billingTheme:', posSettingsList?.billingTheme);
    
    // Try to get theme from POS settings, fallback to localStorage, default to 'classic'
    const savedTheme = posSettingsList?.billingTheme || localStorage.getItem('billingTheme');
    const theme = savedTheme || 'classic';
    console.log('Setting billingTheme to:', theme);
    setBillingTheme(theme);
  }, [posSettingsList]);

  // Keep imageUrl map updated for PosReceiptTemplate whenever receiptData or cartItems change
  useEffect(() => {
    const imgMap = {};
    (cartItems || []).forEach((item) => {
      if (item?.imageUrl && item?._id) imgMap[item._id] = item.imageUrl;
    });
    window.__receiptImageUrlMap = imgMap;
    window.dispatchEvent(new Event('receiptImageMapUpdated'));
  }, [cartItems, receiptData]);

  useEffect(() => {
    let printSettingsString = localStorage.getItem('PrinterSettings');
    let printSettings = JSON.parse(printSettingsString);

    if (dialogOpen === "invoicePrint"
      // || dialogOpen === "deliveryPrint"// upated on san 11/6/25
    ) {
      setTimeout(() => {
        if (printSettings?.receiptAuto) {
          receiptPrintClick();
        }
      }, 0);
    } else if (dialogOpen === "autoPrintKot") {
      setTimeout(() => {
        if (printSettings?.kotAuto) {
          kotPrintClick(kotSingleData);
        }
      }, 0);
    }
  }, [dialogOpen]);

  // verify pass
  const verifyPass = (password) => {
    const body = {
      password: password,
      shiftId: userShiftpk,
      postDate: `${today} ${getCurrentTime()}`,
    }
    getVerifypassword(body, setSuccessSnackbar,
      setErrorSnackbar,
      setSnackMsg);
  };
  // checkin
  useEffect(() => {
    if (checkInPass?.data?.checkIn == true) {
      setShowSecondCheckInPopup(false);
      // setShowCheckinPopup(false);
    }
  }, [checkInPass]);

  // userShiftpk
  useEffect(() => {

    getCheckInDetail({ shiftId: userShiftpk })
    // This effect runs once on component mount
    //  {checkInDetail?.data?.checkIn==="true" &&
    //   setShowCheckinPopup(true);}

  }, []);

  useEffect(() => {
    if (
      (checkInDetail?.data?.checkIn === false || checkInDetail?.data?.checkIn === "false") && shiftStatus?.isBranchWise === true &&
      !showSecondCheckInPopup
    ) {
      setShowCheckinPopup(true); // Show the first popup
    } else {
      setShowCheckinPopup(false); // Hide the first popup
    }
  }, [checkInDetail, showSecondCheckInPopup]); // Include showSecondCheckInPopup in the dependency array
// console.log(btnClicked);


  return (
    <>
      <div className="global-page-parent-container billing-parent-container">
        {btnClicked === "payment" ? (
          <BillingPayment 
            setCustomerDisplayQRInfo={setCustomerDisplayQRInfo}
            upiPaymentSuccessData={upiPaymentSuccessData}
            upiPaymentFailedData={upiPaymentFailedData}
            setUpiPaymentSuccessData={setUpiPaymentSuccessData}
            setUpiPaymentFailedData={setUpiPaymentFailedData}
          />
        ) : btnClicked === "viewOrder" || btnClicked === "heldOrder" ? (
          <ViewOrders />
        ) : btnClicked === "floorPlan" || btnClicked === "tableChange" ? (
          <BillingFloorPlan />
        ) : btnClicked === "reservation" ? (
          <ReservationBilling />
        ) : billingTheme === 'premium' ? (
          <>
            <TopBar />
            <PremiumBillingTheme
              productList={productsForTheme}
              tableLoading={tableLoading}
              handleProductClick={addToCart}
              cartItems={cartItems}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              handleDeleteCartItem={handleDeleteCartItem}
              handleNoteClick={(index) => {
                setSelectedCartRow(index);
                dispatch(setDialogBox('addNote'));
              }}
              subTotal={calculateTotals(cartItems)?.subTotal || 0}
              taxTotal={(calculateTotals(cartItems)?.totalInclusive || 0) + (calculateTotals(cartItems)?.totalExclusive || 0)}
              grandTotal={calculateTotals(cartItems)?.amtTotal || 0}
              decimalPosition={decimalPosition}
              categoryList={filteredCategories}
              selectedCategory={selectedCategory}
              handleCategoryClick={(cat) => {
                categoryOnClick(cat._id)();
              }}
              categoryLoading={categoryLoading}
              subCategoryList={filteredPosCategoryList}
              selectedSubCategory={selectedPOSCategory}
              handleSubCategoryClick={(subCat) => {
                posCategorySelect(subCat);
              }}
              subCategoryLoading={posCategoryLoading}
              specialItemsOpen={specialItemsOpen}
              toggleSpecialItems={toggleSpecialItems}
              specialItemsList={specialItemsListForBilling}
              specialItemCat={specialItemCat}
              handleSpecialItemClick={specialItemsClick}
              vegFilter={selectedPIndex}
              handleVegFilterClick={handleVegFilterClick}
              onCheckout={finalPlaceOrder("paymentOrder")}
              onAddOrder={() => dispatch(setDialogBox("confirmOrder"))}
              onHold={holdOrderClick}
              onQuickBill={quickBillOrder}
              onTransferTable={transferTableClick}
              singleOrderInfo={singleOrderInfo}
              billType={billType}
              floors={floors}
            />
          </>
        ) : (
          <div className="billing-main-container">
            <div className="billing-left-container" style={{ width: "calc(70% - 5px)" }}
            >
              <TopBar />

              <div className="billing-left-button">
                {categoryLoading ? (
                  <div ref={categoryArrayRef} className="billing-array" style={{ gap: "6px", overflowX: "hidden" }}>
                    {[...Array(15)]?.map((r, i) => (
                      <div key={i} className="billing-new-category-single">
                        <Skeleton width={"90px"} height="100px" />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div ref={categoryArrayRef} className="billing-array">
                    {filteredCategories?.length !== 0 ? (
                      filteredCategories?.map((text, i) => (
                        <div
                          onClick={categoryOnClick(text?._id)}
                          key={i}
                          className={`billing-new-category-single ${selectedCategory === text?._id ? "selected-category-single" : ""
                            }`}
                        >
                          <CachedImage src={text?.imageUrl || brokenImg} alt="" />
                          <p>{text?.categoryName}</p>
                        </div>
                      ))
                    ) : (
                      <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
                        <CategoryEmptyAnimation />
                        <p style={{ border: "none", margin: "0", padding: "0" }}>
                          No categories to display
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {/* <div className="billing-left-button">
                {categoryLoading ? (
                  <div
                    ref={categoryArrayRef}
                    className="billing-array"
                    style={{ gap: "6px", overflowX: "hidden" }}
                  >
                    {[...Array(15)]?.map((r, i) => (
                      <div key={i} className="billing-new-category-single">
                        <Skeleton width={"90px"} height="100px" />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div ref={categoryArrayRef} className="billing-array">
                    {CategoryList !== undefined &&
                    CategoryList?.length !== 0 ? (
                      CategoryList?.map((text, i) => (
                        <div
                          onClick={categoryOnClick(text?._id)}
                          key={i}
                          className={`billing-new-category-single ${
                            selectedCategory === text?._id
                              ? "selected-category-single"
                              : ""
                          }`}
                        >
                          <CachedImage src={text?.imageUrl || brokenImg} alt="" />
                          <p>{text?.categoryName}</p>
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        <CategoryEmptyAnimation />
                        <p
                          style={{ border: "none", margin: "0", padding: "0" }}
                        >
                          Category Not found !!
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div> */}

              <div className="products-list">
                <div className="special-items">
                  {canUseSpecialItems && (
                    <>
                      <div
                        className="top justify-space-between"
                        onClick={() => {

                          specialItemsListForBilling.length === 0 && listSpecialItemsForBilling({
                            branchId: userBranchId,
                            day: getTodaysLowerCaseDay(),
                          });
                          dispatch(
                            setDialogBox(
                              dialogOpen === "specialOffer" ? null : "specialOffer"
                            )
                          );
                          dialogOpen === "specialOffer" &&
                            specialItemCat !== null &&
                            specialItemsClick({ _id: specialItemCat });
                        }}
                      >
                        <p>Special Items</p>
                        <LocalOfferIcon
                          sx={{ color: "#db1919", fontSize: "1rem" }}
                        />
                      </div>
                      {dialogOpen === "specialOffer" && (
                        <div className="category-list-menu">
                          <div
                            className="tab justify-space-between"
                            style={{
                              backgroundColor:
                                specialItemCat === "combo" && "#1a0800",
                            }}
                            onClick={() => specialItemsClick({ _id: "combo" })}
                          >
                            COMBO OFFERS
                            {specialItemCat === "combo" && <ArrowRightIcon />}
                          </div>
                          {specialItemsListForBilling.length !== 0 ? (
                            <>
                              {specialItemsListForBilling?.map((r, i) => (
                                <div
                                  key={i}
                                  className="tab justify-space-between"
                                  style={{
                                    backgroundColor:
                                      specialItemCat === r?._id && "#1a0800",
                                  }}
                                  onClick={() => specialItemsClick(r)}
                                >
                                  {r?.name}
                                  {specialItemCat === r?._id && <ArrowRightIcon />}
                                </div>
                              ))}
                            </>
                          ) : (
                            <div
                              className="tab"
                              style={{ justifyContent: "center" }}
                            >
                              No Items found !!
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                  <div className="veg-selection">
                    <p
                      className={
                        selectedPIndex === "non-veg" ? "selected-p" : ""
                      }
                      onClick={() => {
                        categoryListAPICall({
                          type:
                            selectedPIndex === "non-veg" ? undefined : false,
                          isPos: true,
                          branchId: userBranchId
                        });
                        setSelectedPIndex(
                          selectedPIndex === "non-veg" ? null : "non-veg"
                        );
                      }}
                    >
                      Non-veg
                    </p>
                    <p
                      className={selectedPIndex === "veg" ? "selected-p" : ""}
                      onClick={() => {
                        categoryListAPICall({
                          type: selectedPIndex === "veg" ? undefined : true,
                          isPos: true,
                          branchId: userBranchId
                        });
                        setSelectedPIndex(
                          selectedPIndex === "veg" ? null : "veg"
                        );
                      }}
                    >
                      Veg
                    </p>
                  </div>
                  <div className="category-list">
                    <ArrowPath selectedCategory={selectedCategory} />
                  </div>
                  <div className="category-list-menu">
                    {posCategoryLoading ? (
                      [...Array(10)].map((r) => (
                        <div key={r} className="tab">
                          <Skeleton
                            width={"100%"}
                            height={"40px"}
                            sx={{ backgroundColor: "#fff" }}
                          />
                        </div>
                      ))
                    ) : filteredPosCategoryList !== undefined &&
                      filteredPosCategoryList.length !== 0 ? (
                      filteredPosCategoryList?.map((r, i) => (
                        <div
                          key={i}
                          className="tab"
                          onClick={() => posCategorySelect(r)}
                        >
                          {r?.name}
                        </div>
                      ))
                    ) : (
                      <div className="tab" style={{ justifyContent: "center" }}>
                        Sub category not found
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ flex: "1", position: "relative" }}>
                  <ProductCreatePopup style={{ position: "absolute", bottom: "0", right: "10px", zIndex: "50" }} />
                  <ProductsList 
                    selectedCategory={selectedCategory} 
                    isLoading={isLoading} 
                    addToCart={addToCart} 
                    specialItemCat={specialItemCat}
                    isProductAllowedForDevice={isProductAllowedForDevice}
                  />
                </div>
              </div>
            </div>
            <>
              {cartItems?.length !== 0 ? (
                <div className="flex-column">
                  <div className="cart-table-top">
                    {/* <p>Order ID</p> */}
                    <p>{singleOrderInfo?.name || "New Order"}</p>
                    {singleOrderInfo !== null &&
                      billType === "DINEIN" &&
                      singleOrderInfo?.tableId.length !== 0 ? (
                      <>
                        <p>
                          {singleOrderInfo?.tableNames.map((tableName, index) => (
                            <>
                              {index === 0 && singleOrderInfo?.tableNames.length - 1 > 0 && "("}
                              {tableName}
                              {index !== singleOrderInfo?.tableNames.length - 1 && ","}
                              {index === singleOrderInfo?.tableNames.length - 1 && singleOrderInfo?.tableNames.length - 1 > 0 && ")"}
                            </>
                          ))}

                          {singleOrderInfo.chairId.length !== 0 &&
                            `/CH-${singleOrderInfo.chairId.length}`}
                        </p>
                        {/* <p>{selectedTableNames.join(",")}</p> */}
                        {/* <p>T8/C-4</p> */}
                        <button
                          onClick={transferTableClick}
                          className="btn justify-center"
                          style={{
                            whiteSpace: "nowrap",
                            width: "auto",
                            gap: "5px",
                          }}
                        >
                          <TableRestaurantTwoToneIcon />
                          Transfer
                        </button>
                      </>
                    ) : (
                      singleOrderInfo !== null &&
                      billType === "DINEIN" && (
                        <button
                          onClick={transferTableClick}
                          className="btn justify-center"
                          style={{
                            whiteSpace: "nowrap",
                            width: "auto",
                            gap: "5px",
                          }}
                        >
                          Add <TableRestaurantTwoToneIcon />
                        </button>
                      )
                    )}
                  </div>
                  <div
                    className="billing-rightside-container"
                  // onMouseLeave={handleMouseEnter}
                  >
                    <div
                      className="billing-right-card">
                      {cartItems.map((cartItem, index) => (
                        <div
                          key={index}
                          onClick={cartRowClick(index)}
                          className="billing-card-content"
                          style={{
                            borderLeft:
                              selectedCartRow === index
                                ? "7px solid #088051"
                                : cartItem.itemType === 3 &&
                                "7px solid rgb(211 20 0)",
                            // paddingBottom:cartItem.itemType===3?"15px":"2px"
                          }}
                        >
                          <div className="billing-card-image justify-center">
                            {cartItem?.imageUrl === undefined ? (
                              <DoneOutlineIcon sx={{ color: "green" }} />
                            ) : (
                              <CachedImage
                                src={
                                  cartItem?.imageUrl !== null &&
                                    cartItem?.imageUrl.length !== 0
                                    ? cartItem?.imageUrl
                                    : dummyProductItemImg
                                }
                                alt=""
                              />
                            )}
                          </div>
                          <div className="billing-card-details">
                            <h1>{cartItem.productName}</h1>
                            {cartItem.customerNote && (
                              <p
                                style={{ whiteSpace: 'pre-line', cursor: 'pointer' }}
                                onDoubleClick={(e) => {
                                  e.stopPropagation();
                                  const updated = [...cartItems];
                                  updated[index].customerNote = null;
                                  setCartItems(updated);
                                  setIsCartModified(!isCartModified);
                                }}
                                title="Double-click to remove note"
                              >{cartItem.customerNote}</p>
                            )}
                          </div>
                          <div className="cart-buttons-ctn">
                            <input
                              ref={qtyInputRefs.current[index]}
                              onClick={(e) => {
                                inputSelection === "qty" && e.stopPropagation();
                              }}
                              type="number"
                              value={cartItem.quantity}
                              style={{
                                border:
                                  selectedCartRow === index &&
                                  inputSelection === "qty" &&
                                  "1px solid #088051",
                              }}
                              onChange={cartQuantityChange(index, "quantity")}
                              readOnly={
                                selectedCartRow !== index ||
                                inputSelection !== "qty"
                              }
                              onFocus={(e) => e.target.select()}
                              min={0}
                            />
                          </div>
                          <div
                            className="billing-cart-total-price"
                            style={{ fontSize: "0.8rem" }}
                          >
                            <p>{currencyDetails?.symbol} {cartItem?.subTotalWoTax?.toFixed(decimalPosition)}</p>
                            <p className="sub">
                              {currencyDetails?.symbol}
                              <input
                                type="number"
                                min={0}
                                ref={salesPriceRefs.current[index]}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                style={{
                                  width: `${String(cartItem?.salesPrice).length * 9 + 2
                                    }px`,
                                  border:
                                    selectedCartRow === index &&
                                    "1px solid #088051",
                                  marginLeft:
                                    selectedCartRow === index &&
                                    "5px",
                                  minWidth: "15px",
                                }}
                                onFocus={(e) => e.target.select()}
                                onChange={cartQuantityChange(
                                  index,
                                  "salesPrice"
                                )}
                                onBlur={handleMouseEnter}
                                value={cartItem?.salesPrice}
                                readOnly={
                                  selectedCartRow !== index
                                }
                              />
                            </p>
                          </div>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(index);
                            }}
                            disabled={cartItem?.imageUrl === undefined}
                          >
                            <i
                              class={`bi bi-trash3 ${cartItem?.imageUrl === undefined
                                ? ""
                                : "delete-icon"
                                }`}
                              style={{ fontSize: "15px" }}
                            ></i>
                          </IconButton>
                          {/* {cartItem.itemType===3 &&
                    
                  <p className="combo-list">{cartItem?.productList.map((item)=>item.productName).join(', ')}</p>
                  
                  } */}
                        </div>
                      ))}
                    </div>

                    {/* AI Smart Recommendations - Permission controlled */}
                    {canUseSmartSuggestions && (
                      <SmartRecommendations
                        cartItems={cartItems}
                        customerId={customer?._id}
                        orderType={billType}
                        onAddToCart={addToCart}
                        isExpanded={cartItems.length > 0}
                      />
                    )}

                    {/* Customer Intelligence Panel - Permission controlled */}
                    {canUseCustomerIntelligence && customer?._id && (
                      <CustomerIntelligence
                        customerId={customer?._id}
                        customerName={customer?.name}
                        onSuggestProduct={(productName) => {
                          // Find product by name and add to cart
                          const product = productsForTheme?.find(p => 
                            p.productName?.toLowerCase().includes(productName.toLowerCase())
                          );
                          if (product) addToCart(product);
                        }}
                      />
                    )}

                    <div
                      // onMouseEnter={handleMouseEnter}
                      // onMouseLeave={handleMouseEnter}
                      style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
                      <div className="subtotal-amount-ctn">
                        <p>Subtotal</p>
                        <input
                          type="text"
                          value={
                            `${cartItems?.reduce(
                              (sum, item) => sum + item?.subTotalWoTax,
                              0
                            )} ${currencyDetails?.symbol}`}
                          readOnly
                        />
                      </div>
                      {/* <div className="exc-tax-amount-ctn" style={{ display: "flex", flexDirection: "row" }}>
                        <p>Exclusive Tax</p>
                       
                        <input
                          type="text"
                          value={cartItems?.exclusiveTax}
                          readOnly
                        />
                      </div> */}
                      {/* <div className="total-amount">
                        <div className="total">
                          <p>Exclusive Tax</p>
                          <p>Inclusive Tax</p>
                          <h1>Total amount</h1>
                        </div>
                        <div className="total-a">
                          <p style={{ color: "red" }}>
                            {cartItems.reduce((sum, item) => sum + (item.exclusiveTax || 0), 0).toFixed(2)}
                          </p>
                          <p style={{ color: "red" }}>
                            {cartItems.reduce((sum, item) => sum + (item.inclusiveTax || 0), 0).toFixed(2)}
                          </p>
                          <h1>
                            {Math.round(cartItems.reduce((sum, item) => sum + (item.lineTotal || 0), 0))}
                          </h1>
                        </div>
                      </div> */}
                      <div className="total-amount-container">
                        <div
                          className="toggle-total-btn"
                          onClick={() => setIsTotalExpanded(!isTotalExpanded)}
                        >
                          <span>Show Total</span>
                          <i className={`bi bi-chevron-${isTotalExpanded ? 'up' : 'down'}`}></i>
                        </div>

                        <div className={`total-amount-wrapper ${isTotalExpanded ? 'expanded' : ''}`}>
                          <div className="total-amount">
                            <div className="total">
                              <p>Exclusive Tax</p>
                              <p>Inclusive Tax</p>
                              <h1>Total amount</h1>
                            </div>
                            <div className="total-a">
                              <p style={{ color: "red" }}>
                                {cartItems.reduce((sum, item) => sum + (item.exclusiveTax || 0), 0).toFixed(2)}
                              </p>
                              <p style={{ color: "red" }}>
                                {cartItems.reduce((sum, item) => sum + (item.inclusiveTax || 0), 0).toFixed(2)}
                              </p>
                              <h1>
                                {Math.round(cartItems.reduce((sum, item) => sum + (item.lineTotal || 0), 0))}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="billing-keypad-section">
                        <div className="billing-input-section">
                          <div className="row">
                            <button onClick={() => handleButtonClick("7")}>
                              7
                            </button>
                            <button onClick={() => handleButtonClick("8")}>
                              8
                            </button>
                            <button onClick={() => handleButtonClick("9")}>
                              9
                            </button>
                          </div>
                          <div className="row">
                            <button onClick={() => handleButtonClick("4")}>
                              4
                            </button>
                            <button onClick={() => handleButtonClick("5")}>
                              5
                            </button>
                            <button onClick={() => handleButtonClick("6")}>
                              6
                            </button>
                          </div>
                          <div className="row">
                            <button onClick={() => handleButtonClick("1")}>
                              1
                            </button>
                            <button onClick={() => handleButtonClick("2")}>
                              2
                            </button>
                            <button onClick={() => handleButtonClick("3")}>
                              3
                            </button>
                          </div>
                          <div className="row">
                            <button onClick={() => handleButtonClick(".")}>
                              .
                            </button>
                            <button onClick={() => handleButtonClick("0")}>
                              0
                            </button>
                            <button
                              className="billing-Hold-button"
                              // disabled={singleOrderInfo!==null}
                              onClick={holdOrderClick}
                            // style={{cursor:singleOrderInfo!==null?"not-allowed":"pointer"}}
                            >
                              Hold
                            </button>
                          </div>
                          <div className="row">
                            {inputSelection === "note" ? (
                              <button
                                onClick={() => keyPadTypeSelection(null)}
                                className="keypad-qty-btn closekey-pad-btn"
                                style={{ backgroundColor: "#478045" }}
                              >
                                <DoneOutlineIcon />
                              </button>
                            ) : (
                              <button
                                disabled={selectedCartRow === null}
                                onClick={() => keyPadTypeSelection("note")}
                                className={`${selectedCartRow === null
                                  ? "keypad-qty-btn-enable"
                                  : ""
                                  } keypad-qty-btn`}
                              >
                                Note
                              </button>
                            )}
                            {inputSelection === "qty" ? (
                              <button
                                disabled={selectedCartRow === null}
                                onClick={() => keyPadTypeSelection(null)}
                                className="keypad-qty-btn closekey-pad-btn"
                                style={{ backgroundColor: "#478045" }}
                              >
                                <DoneOutlineIcon />
                              </button>
                            ) : (
                              <button
                                onClick={() => keyPadTypeSelection("qty")}
                                disabled={selectedCartRow === null}
                                className={`${selectedCartRow === null
                                  ? "keypad-qty-btn-enable"
                                  : ""
                                  } keypad-qty-btn`}
                              >
                                Qty
                              </button>
                            )}
                            {inputSelection === "price" ? (
                              <button
                                onClick={() => keyPadTypeSelection(null)}
                                className="keypad-qty-btn closekey-pad-btn"
                                style={{ backgroundColor: "#478045" }}
                              >
                                <DoneOutlineIcon />
                              </button>
                            ) : (
                              <button
                                onClick={() => keyPadTypeSelection("price")}
                                disabled={selectedCartRow === null}
                                className={`${selectedCartRow === null
                                  ? "keypad-qty-btn-enable"
                                  : ""
                                  } keypad-qty-btn`}
                              >
                                Price
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="billing-keypad-buttons">
                          <button
                            onClick={() => {
                              dispatch(setDialogBox("confirmOrder"));
                            }}
                            className="billing-placeOrder-button"
                          >
                            {singleOrderInfo?.status === "DRAFT" ? "Update" : "Add Order"}
                          </button>
                          <button
                            onClick={finalPlaceOrder("paymentOrder")}
                            className="billing-payment-button"
                          >
                            Payment
                          </button>
                          <button
                            className={`billing-clear-button ${singleOrderInfo?.status === "DRAFT" ? 'disabled-order' : 'quick-bill-btn'}`}
                            onClick={quickBillOrder}
                            disabled={singleOrderInfo?.status === "DRAFT"}
                          >
                            Quick Bill
                          </button>
                          <button
                            className="billing-clear-button"
                            onClick={clearPOSOrder}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex-column">
                  <div className="cart-table-top">
                    {/* <p>Order ID</p> */}
                    {/* <p>{selectedTableNames.join(",")}</p> */}
                    <p>{singleOrderInfo?.name || "New Order"}</p>

                    {singleOrderInfo !== null &&
                      billType === "DINEIN" &&
                      singleOrderInfo?.tableId.length !== 0 ? (
                      <>
                        <p>
                          {singleOrderInfo?.tableNames.map((tableName, index) => (
                            <>
                              {index === 0 && singleOrderInfo?.tableNames.length - 1 > 0 && "("}
                              {tableName}
                              {index !== singleOrderInfo?.tableNames.length - 1 && ","}
                              {index === singleOrderInfo?.tableNames.length - 1 && singleOrderInfo?.tableNames.length - 1 > 0 && ")"}
                            </>
                          ))}

                          {singleOrderInfo.chairId.length !== 0 &&
                            `/CH-${singleOrderInfo.chairId.length}`}
                        </p>
                        <button
                          onClick={transferTableClick}
                          className="btn justify-center"
                          style={{
                            whiteSpace: "nowrap",
                            width: "auto",
                            gap: "5px",
                          }}
                        >
                          <TableRestaurantTwoToneIcon />
                          Transfer
                        </button>
                      </>
                    ) : (
                      singleOrderInfo !== null &&
                      billType === "DINEIN" && (
                        <button
                          onClick={transferTableClick}
                          className="btn justify-center"
                          style={{
                            whiteSpace: "nowrap",
                            width: "auto",
                            gap: "5px",
                          }}
                        >
                          Add <TableRestaurantTwoToneIcon />
                        </button>
                      )
                    )}
                  </div>
                  <div
                    className="billing-rightside-container"
                    style={{
                      backgroundColor: "#fff",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ margin: "0px 0 150px 0", textAlign: "right", padding: "10px" }}>
                      <p style={{ color: "gray", margin: "0", fontSize: "small" }}>powered by </p>
                      <img style={{ width: "30%" }} src={logo} alt="" />
                    </div>
                    <div>
                      <img src={emptyCartItemImg} alt="" />
                      <p style={{ color: "gray" }}>Your cart is empty</p>
                    </div>
                  </div>
                </div>
              )}
            </>
          </div>
        )}

        {/* Voice Ordering FAB - appears on all billing screens - Permission controlled */}
        {canUseVoiceOrdering && (
          <VoiceOrdering
            disabled={btnClicked === "payment" || btnClicked === "viewOrder" || btnClicked === "heldOrder"}
            onAddItems={(items) => {
              // Check if customer selection is mandatory
              if (customerPaymentStatus && !customer) {
                errorSnackMsg("Please select a customer before adding items to cart!");
                return;
              }
              
              // Add all items to cart with their quantities
              setCartItems(prevCart => {
                let updatedCart = [...prevCart];
                
                items.forEach(item => {
                  const qty = item.quantity || 1;
                  const salesPrice = Number(item?.salesPrice ?? item?.unitPrice ?? 0);
                  const existingIndex = updatedCart.findIndex(c => c._id === item._id);
                  
                  if (existingIndex !== -1) {
                    // Item exists, add to quantity
                    updatedCart[existingIndex] = {
                      ...updatedCart[existingIndex],
                      quantity: Number(updatedCart[existingIndex].quantity) + qty
                    };
                  } else {
                    // New item, add to beginning with all required fields for cart calculations
                    const taxes = item?.taxes || [];
                    // If taxes array is empty, includedPrice must be null (backend validation requirement)
                    const includedPrice = taxes.length > 0 ? (item?.includedPrice ?? false) : null;
                    
                    updatedCart = [{
                      ...item,
                      quantity: qty,
                      itemType: productType,
                      salesPrice: salesPrice,
                      minSalesPrice: salesPrice,
                      taxes: taxes,
                      includedPrice: includedPrice,
                      uom: item?.uom || null,
                      // Initialize calculated fields (will be recalculated by calculateAndSetCalculatedValues)
                      subTotalWoTax: salesPrice * qty,
                      lineTotal: salesPrice * qty,
                      exclusiveTax: 0,
                      inclusiveTax: 0
                    }, ...updatedCart];
                  }
                });
                
                return updatedCart;
              });
              
              setIsCartModified(prev => !prev);
              console.log(`✅ Added ${items.length} item(s) to cart from voice order`);
            }}
          />
        )}
      </div>

      {/* invoice bill dialog */}
      <Dialog
        open={dialogOpen === "invoicePrint" || dialogOpen === "deliveryPrint"}
        maxWidth="lg"
        onClose={() => dispatch(setDialogBox(null))}
        onKeyDown={(e) => e.key === "Escape" && dispatch(setDialogBox(null))}
      >
        {/* <Invoice data={invoiceData} /> */}
        <div className="billing-parent-wrapper">
          <div>
            <PosReceiptTemplate />
          </div>
          <div className="invoice-print-icon-container" id="invoicePrintIcon">
            <IconButton
              onClick={() => receiptPrintClick()}
              className="invoice-print-btn"
              sx={{
                backgroundColor: "#d3e3ec",
              }}>
              <PrintOutlined
                className="print-icon"
                sx={{ color: "#000" }}
              />
            </IconButton>
            {/* <IconButton
              sx={{
                backgroundColor: "#d3e3ec",
              }}
              onClick={() => sendMessageToWs()}
            >
              <WhatsAppIcon color="success" />
            </IconButton> */}
          </div>
        </div>
      </Dialog>

      {/* confirm add order dialogue */}
      <Dialog
        open={dialogOpen === "confirmOrder"}
        maxWidth="xs"
        onClose={() => dispatch(setDialogBox(null))}
      >
        <div className="billing-confirm-order-dialog">
          <p className="head">Confirm Order</p>
          <p>Are you sure to confirm order?</p>

          <div
            className="new-global-single-input  auto-complete-new"
            style={{ width: "275px" }}
          >
            <Autocomplete
              options={allActiveEmpList?.filter((obj) => obj?.designationName?.toUpperCase() === "WAITER") || []}
              getOptionLabel={(option) => option?.staff_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Waiter"
                  focused
                  variant="outlined"
                  placeholder="optional"
                />
              )}
              onChange={(e, newValue) => dispatch(setOrderWaiter(newValue))}
              value={waiter}
            />
          </div>
          <div className="justify-center">
            <button
              onClick={() => dispatch(setDialogBox(null))}
              className="btn btn-secondary-outlined"
            >
              Cancel
            </button>
            <button
              onClick={finalPlaceOrder("OrderWoPayment")}
              style={{ backgroundColor: "#139109" }}
              className="btn btn-primary"
            >
              Confirm
            </button>
          </div>
        </div>
      </Dialog>

      {/* Add Note */}
      <Dialog
        open={dialogOpen === "addNote"}
        maxWidth="lg"
        onClose={() => {
          dispatch(setDialogBox(null));
          setInputSelection(null);
        }}
      >
        <div className="billing-confirm-order-dialog">
          <p className="head">Add Note</p>
          <hr className="global-hr" />
          <div style={{ position: "relative", width: "30vw" }}>
            <input
              style={{ height: "40px", margin: "2% 0", width: "100%", paddingRight: "80px" }}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              type="text"
            />
            <div style={{position:"absolute", right: 6, top: 6, display:"flex", gap:6, alignItems:"center", zIndex: 1}}>
              <IconButton
                onClick={saveNoteTemplate}
                title="Save as template"
                size="small"
                aria-label="Save note as template"
              >
                <SaveAltIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={() => setEnableKeybooard(!enableKeybooard)}
                size="small"
                aria-label="Toggle keyboard"
                title="Keyboard"
              >
                <KeyboardIcon color='inherit' fontSize="small" />
              </IconButton>
            </div>
          </div>
          <ListNotes setInput={setInput} input={input} />
          {
            !enableKeybooard &&
            <button
              onClick={cartAddNote}
              className="btn btn-primary"
              style={{ backgroundColor: "#139109", width: "100%" }}
            >
              Add
            </button>}

        </div>
        {
          enableKeybooard &&
          <CustomeKeyBoard setInput={setInput} input={input} enterClick={cartAddNote} />
        }
      </Dialog>

      {/* Backdrop on loading  */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 500 }}
        open={billLoading}
      // onClick={handleClose}
      >
        <Loader />
        {/* <CircularProgress color="inherit" /> */}
      </Backdrop>
      {/* keybboard for touchpad*/}

      {
        keyBoardVisible &&
        <div className="billing-keyboard-position">
          {
            keyBoardVisible === "searchKeyboard" ?
              <CustomeKeyBoard
                input={searchBarInput}
                setInput={(value) => searchInputOnChange(value)}
              /> : ""
          }
        </div>}

      <Dialog open={kotManualDialog === "kotPrint"} onClose={() => dispatch(setKOTManualDialog(null))}>
        <div className="justify-center" style={{ padding: "30px", gap: "15px" }}>
          <ButtonWithIcon
            onClick={() => dispatch(setKOTManualDialog(null))}
            text="Cancel"
            icon={<HighlightOffOutlinedIcon />}
            style={{ background: "#d91818" }}
          />

          <ButtonWithIcon
            text="Print KOT"
            icon={<PrintOutlined />}
            style={{ background: "#003aa9" }}
            onClick={() => kotPrintClick(kotSingleData)}
          />

        </div>
      </Dialog>

      <Dialog open={dialogOpen === "authPassword" || dialogOpen === "authPasswordPayment"} onClose={() => dispatch(setDialogBox(false))}>
        <UpdateOrderAuth text={"Update Order"} authType="orderEdit" submitClick={finalPlaceOrder(dialogOpen === "authPasswordPayment" ? "paymentOrder" : "OrderWoPayment")} />
      </Dialog>
      <div className="receipt-print-parent">
        <div ref={kotPrintRef}>
          <KotPrint
            billNo={kotSingleData?.ordName || "-NIL-"}
            waiter={kotSingleData?.waiterName || "-NIL-"}
            orderDate={kotSingleData?.orderDate || "00/00/0000 00:00:00"}
            orderData={kotSingleData?.orderInfo || []}
            orderType={kotSingleData?.ordType || "---"}
            tokenNumber={kotSingleData?.transNo || "---"}
            kotPrintNotes={JSON.parse(localStorage.getItem('PrinterSettings') || '{}')?.kotPrintNotes || false}
          />
        </div>
      </div>

      <div className='receipt-print-parent'>
        <div ref={invoicePrint} className='pos-print-container'>
          <PosReceiptTemplate />
        </div>
      </div>

      {showCheckinPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-box-head" >
              <div style={{ placeSelf: "end" }}>
                <IconButton
                  onClick={() => {
                    setShowCheckinPopup(false);
                    dispatch(
                      switch_to_billing_screen({ billingBoolean: false })
                    );
                    navigateTo('/userdashboard/dashboardhome');
                  }}
                >
                  <HighlightOffOutlinedIcon
                    sx={{
                      color: "white",
                      fontSize: "30px",
                      fontWeight: "400",
                    }}
                  />
                </IconButton>
              </div>
              <img src={photo} alt="" style={{ borderRadius: "30px", height: "7vh", marginTop: "-31px" }} />

            </div>
            <div style={{ paddingBottom: "11px" }}>
              <p style={{ color: "gray" }}>Employee</p>
              <p>{userInfo?.userName}</p>
              <button className="btn btn-primary" style={{ height: "33px", width: "29%" }} onClick={() => { setShowSecondCheckInPopup(true); setShowCheckinPopup(false); }}>Check In</button>

            </div>
          </div>
        </div>
      )}
      {showSecondCheckInPopup && (
        <div className="popup-overlay">
          <div className="popup-box" style={{ width: "295px" }}>
            <div className="popup-box-head" style={{ display: "flex", justifyContent: "space-between", height: "5vh", paddingInline: "3px" }}>


              <img src={photo} alt="" style={{ borderRadius: "30px", height: "4vh", alignSelf: "center" }} />
              <p style={{ color: "white" }}>{userInfo?.userName}</p>
              <div style={{ placeSelf: "end" }}>
                <IconButton
                  onClick={() => setShowSecondCheckInPopup(false)}
                >
                  <HighlightOffOutlinedIcon
                    sx={{
                      color: "white",
                      fontSize: "30px",
                      fontWeight: "400",
                    }}
                  />
                </IconButton>
              </div>
            </div>
            <div style={{ paddingBottom: "11px" }}>
              <div style={{ paddingInline: "10px" }}>
                <p style={{ justifySelf: "start", margin: "17px 7px 3px 3px" }}>Password</p>
                <input
                  // type="password"
                  // placeholder="Enter Password"
                  style={{
                    backgroundColor: "#ede9e9",
                    width: "100%",
                    padding: "8px",
                    marginTop: "10px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                  }}
                  onChange={(e) => setPassword(e.target.value)} // Use a state variable for the password
                />
              </div>

              <div style={{ display: "flex", gap: "10px", justifyContent: "center", paddingTop: "10px" }}>
                <button className="btn btn-success" style={{ fontWeight: "bold", color: "black", backgroundColor: "white", width: "78px", border: "solid 1px black" }} onClick={() => {
                  // perform check-in logic here
                  setShowSecondCheckInPopup(false);
                  setShowCheckinPopup(true);
                }}>
                  Cancel
                </button>
                <button className="btn btn-secondary" style={{ color: "white", backgroundColor: "red", width: "78px" }} onClick={() => verifyPass(password)}>
                  Check In
                </button>
              </div>
            </div>
          </div>

        </div>
      )}
      <SuccessSnackbar
        open={successSnackbar}
        handleClose={closeSuccessSnackbar}
        message={snackMsg}
      />

      <ErrorSnackbar
        open={errorSnackbar}
        handleClose={closeErrorSnackbar}
        message={snackMsg}
      />
    </>
  );
};